import { h } from 'preact';

function Background() {
  return (
    <g clip-path="url(#a)">
      <path
        d="M208.49 143.28c-14.71-2.4-28.9 26.77-34.15 41.66 13.14 3.38 43.83 14.26 60.05 20.27 1.13-18.01-7.51-58.92-25.89-61.92l-.01-.01Z"
        fill="#B6CC9E"
      />
      <path
        d="M251.789 138.07c-19.46-3.17-38.23 35.29-45.18 54.91 17.38 4.45 57.99 18.8 79.43 26.71 1.49-23.75-9.93-77.67-34.25-81.63v.01Z"
        fill="#B6CC9E"
      />
      <path
        d="M79.03 160.03c5.798 0 10.5-4.701 10.5-10.5s-4.702-10.5-10.5-10.5c-5.8 0-10.5 4.701-10.5 10.5s4.7 10.5 10.5 10.5Z"
        fill="#fff"
      />
      <path
        d="M93.83 157.03a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9Zm-25.68 10.11c5.782 0 10.47-4.455 10.47-9.95 0-5.495-4.688-9.95-10.47-9.95-5.783 0-10.47 4.455-10.47 9.95 0 5.495 4.687 9.95 10.47 9.95Z"
        fill="#fff"
      />
      <path
        d="M79.53 171.6c6.074 0 11-4.455 11-9.95 0-5.495-4.926-9.95-11-9.95-6.076 0-11 4.455-11 9.95 0 5.495 4.924 9.95 11 9.95Z"
        fill="#fff"
      />
      <path
        d="M92.2 171.6c6.074 0 10.999-4.455 10.999-9.95 0-5.495-4.925-9.95-11-9.95s-11 4.455-11 9.95c0 5.495 4.925 9.95 11 9.95Z"
        fill="#fff"
      />
      <path
        d="M101.66 167.14c6.362 0 11.52-4.455 11.52-9.95 0-5.495-5.158-9.95-11.52-9.95-6.363 0-11.52 4.455-11.52 9.95 0 5.495 5.157 9.95 11.52 9.95Zm56.479-19.69c3.811 0 6.9-2.794 6.9-6.24s-3.089-6.24-6.9-6.24c-3.811 0-6.9 2.794-6.9 6.24s3.089 6.24 6.9 6.24Z"
        fill="#fff"
      />
      <path d="M149.879 140.2a6.59 6.59 0 0 0 6.59-6.59 6.59 6.59 0 1 0-6.59 6.59Z" fill="#fff" />
      <path
        d="M159.15 138.3a5.64 5.64 0 1 0 0-11.28 5.64 5.64 0 0 0 0 11.28Zm-16.101 6.35c3.629 0 6.57-2.794 6.57-6.24s-2.941-6.24-6.57-6.24c-3.628 0-6.57 2.794-6.57 6.24s2.942 6.24 6.57 6.24Z"
        fill="#fff"
      />
      <path
        d="M150.189 147.45c3.811 0 6.9-2.794 6.9-6.24s-3.089-6.24-6.9-6.24c-3.811 0-6.9 2.794-6.9 6.24s3.089 6.24 6.9 6.24Z"
        fill="#fff"
      />
      <path
        d="M164.07 144.65c3.987 0 7.22-2.794 7.22-6.24s-3.233-6.24-7.22-6.24c-3.988 0-7.22 2.794-7.22 6.24s3.232 6.24 7.22 6.24Zm48.35-37.41c6.351 0 11.5-5.149 11.5-11.5s-5.149-11.5-11.5-11.5-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5Z"
        fill="#fff"
      />
      <path
        d="M228.62 103.96c5.445 0 9.86-4.414 9.86-9.86 0-5.445-4.415-9.86-9.86-9.86-5.446 0-9.86 4.415-9.86 9.86 0 5.446 4.414 9.86 9.86 9.86Zm-28.13 11.07c6.334 0 11.47-4.88 11.47-10.9 0-6.02-5.136-10.9-11.47-10.9-6.335 0-11.47 4.88-11.47 10.9 0 6.02 5.135 10.9 11.47 10.9Z"
        fill="#fff"
      />
      <path
        d="M212.96 119.91c6.649 0 12.04-4.88 12.04-10.9 0-6.02-5.391-10.9-12.04-10.9-6.65 0-12.04 4.88-12.04 10.9 0 6.02 5.39 10.9 12.04 10.9Z"
        fill="#fff"
      />
      <path
        d="M226.84 119.91c6.649 0 12.04-4.88 12.04-10.9 0-6.02-5.391-10.9-12.04-10.9-6.65 0-12.04 4.88-12.04 10.9 0 6.02 5.39 10.9 12.04 10.9Z"
        fill="#fff"
      />
      <path
        d="M237.199 115.03c6.97 0 12.62-4.88 12.62-10.9 0-6.02-5.65-10.9-12.62-10.9-6.97 0-12.62 4.88-12.62 10.9 0 6.02 5.65 10.9 12.62 10.9Z"
        fill="#fff"
      />
      <path
        d="M153.58 246.98c-14.71-2.4-28.9 26.77-34.15 41.66 13.14 3.38 43.83 14.26 60.05 20.27 1.13-18.01-7.51-58.92-25.89-61.92l-.01-.01Z"
        fill="#B6CC9E"
      />
      <path
        d="M385.32 314.45c36.52-3.37 78.48-5.03 106.93-25.33 15.31-10.93 17.84-14.96 22.96-26.13 15.5-33.8 14.32-71.61 2.28-123.41-6.95-29.88-30.23-64.74-55.01-86.86-27.64-24.67-70.61-35.91-102.91-43.43-16.6-3.86-60.08-9.32-88.06-9.29-28.54.03-97.69 6.78-125.07 14.97-14.33 4.29-28.76 8.61-42.13 15.39-13.6 6.9-25.87 16.22-37.76 25.86-21.02 17.04-36.27 35.32-50.78 62.65C7.14 135.11-.91 169.71.08 188.14c1.6 29.59 1.26 43.39 17 68.31 16.12 25.52 36.2 33.28 67.67 46.2 0 0 137.13 33.33 300.9 9.77"
        fill="#DCF6FF"
      />
      <path
        d="M449.479 265.1c-14.69-28.88-32.94-41.07-55.69-53.85-36.68-20.61-71.92-41.06-115.95-41.06-5.39 0-13.22-.66-18.53-.47-5.31-.19-13.14.47-18.53.47-44.04 0-86.51 9.95-117.65 38.25-25.46 23.13-41.37 30.17-46.49 62.16-1.85 11.58-.81 29.17 13.97 34.39.87.31 4.47 1.34 5.36 1.55 8.2 1.9 53.09 10.9 142.92 13.36 7.27.2 14.06.37 20.42.5 6.36-.14 13.15-.3 20.42-.5 89.83-2.46 128.31-7.98 140.04-8.81 6.98-.49 24.25-2.52 27.89-3.91 19.35-7.35 7.43-31.07 1.83-42.08h-.01Z"
        fill="#C5D8AD"
      />
      <path d="m89.34 295.25.91 2.24-.51.03-.4-2.27Z" fill="#87AC57" />
      <path d="m90.59 295.23-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m89.99 295.2.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m92.64 295.71-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m92.04 295.68.37 2.28-.51-.01.14-2.27ZM90.38 297l.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m91.63 296.97-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m91.03 296.94.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m93.06 298.09-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m92.46 298.06.37 2.28-.51-.01.14-2.27Zm-3.74-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m89.96 297.96-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m89.37 297.93.36 2.28-.51-.01.15-2.27Zm.02-10.01.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m90.64 287.9-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m90.04 287.87.37 2.28-.51-.02.14-2.26Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m92.689 288.38-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m92.1 288.35.36 2.28-.51-.01.15-2.27Zm-1.67 1.31.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m91.68 289.64-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m91.08 289.61.37 2.28-.51-.01.14-2.27Zm.79 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m93.109 290.76-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m92.52 290.73.36 2.28-.51-.01.15-2.27Zm-3.75-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m90.01 290.63-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m89.42 290.6.36 2.28-.51-.01.15-2.27Zm8.34 7.83.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m99 298.41-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m98.41 298.38.36 2.28-.51-.01.15-2.27Zm1.4.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m101.06 298.89-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m100.459 298.86.36 2.28-.5-.01.14-2.27Zm-1.659 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m100.05 300.16-.06 2.27-.5-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m99.45 300.13.36 2.28-.5-.02.14-2.26Zm.779 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m101.48 301.28-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m100.879 301.25.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m98.38 301.14-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m97.78 301.11.37 2.28-.51-.01.14-2.27Zm9.98-64.2.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m109.01 236.89-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m108.41 236.86.37 2.28-.51-.01.14-2.27Zm1.409.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m111.07 237.37-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m110.469 237.34.36 2.28-.5-.01.14-2.27Zm-1.659 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m110.05 238.63-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m109.459 238.6.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m111.49 239.75-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m110.889 239.72.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m108.39 239.62-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m107.789 239.59.37 2.28-.51-.01.14-2.27Zm-6.649-7.83.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m102.39 231.74-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m101.789 231.71.37 2.28-.51-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m104.45 232.22-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m103.849 232.19.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m103.43 233.49-.05 2.27-.5-.02.55-2.25Z" fill="#87AC57" />
      <path
        d="m102.839 233.46.36 2.28-.51-.02.15-2.26Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m104.87 234.61-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m104.269 234.58.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m101.77 234.47-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m101.169 234.44.36 2.28-.5-.01.14-2.27Zm13.351 1.15.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m115.759 235.57-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m115.17 235.54.36 2.28-.51-.01.15-2.27Zm1.399.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m117.82 236.05-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m117.219 236.02.36 2.28-.5-.01.14-2.27Zm-1.659 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m116.81 237.31-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m116.209 237.28.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m118.24 238.43-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m117.639 238.4.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m115.14 238.3-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m114.539 238.27.37 2.28-.51-.01.14-2.27Zm-13.399 3.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m102.39 241.78-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m101.789 241.75.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m104.44 242.26-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m103.849 242.23.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m103.429 243.53-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m102.839 243.5.36 2.28-.51-.01.15-2.27Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m104.86 244.65-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m104.269 244.62.36 2.28-.51-.01.15-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m101.77 244.51-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m101.169 244.48.36 2.29-.5-.02.14-2.27Zm17.69.45.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m120.1 244.9-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m119.509 244.87.36 2.29-.51-.02.15-2.27Zm1.4.54.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m122.16 245.39-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m121.559 245.35.37 2.29-.51-.02.14-2.27Zm-1.66 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m121.15 246.65-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m120.549 246.62.37 2.28-.51-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m122.58 247.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m121.979 247.74.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m119.48 247.64-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m118.879 247.61.37 2.28-.51-.01.14-2.27Zm10.491-9.63.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m130.611 237.96-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m130.02 237.93.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m132.67 238.44-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m132.07 238.41.37 2.28-.51-.01.14-2.27Zm-1.66 1.31.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m131.661 239.7-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m131.06 239.67.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m133.09 240.82-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m132.49 240.79.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m129.991 240.69-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m129.39 240.66.37 2.28-.51-.01.14-2.27Zm6.299-14.37.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m136.929 226.26-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m136.339 226.23.36 2.28-.51-.01.15-2.27Zm1.4.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m138.99 226.74-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m138.389 226.71.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.901 2.24-.5.03-.401-2.27Z"
        fill="#87AC57"
      />
      <path d="m137.98 228.01-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m137.379 227.98.36 2.28-.5-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m139.41 229.13-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m138.809 229.1.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m136.31 228.99-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m135.709 228.96.37 2.29-.51-.02.14-2.27Zm6.411 1.61.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m143.36 230.55-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.77 230.52.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m145.42 231.03-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m144.82 231 .36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m144.411 232.29-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m143.81 232.26.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m145.84 233.41-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m145.24 233.38.36 2.29-.5-.02.14-2.27Zm-3.75-.07.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m142.741 233.28-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.14 233.25.37 2.28-.51-.01.14-2.27Zm35.889-10.33.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m179.269 222.9-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m178.679 222.87.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m181.33 223.38-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m180.729 223.35.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m180.32 224.64-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m179.719 224.61.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m181.749 225.76-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m181.149 225.73.37 2.28-.51-.01.14-2.27Zm-3.75-.07.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m178.65 225.63-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m178.049 225.6.37 2.28-.51-.01.14-2.27Zm6.971 3.74.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m186.27 229.32-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m185.669 229.29.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m188.32 229.8-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m187.729 229.77.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m187.309 231.07-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m186.719 231.04.36 2.28-.51-.02.15-2.26Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m188.739 232.19-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m188.149 232.16.36 2.28-.51-.01.15-2.27Zm-3.75-.08.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m185.65 232.05-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m185.049 232.02.36 2.28-.5-.01.14-2.27Zm-8.07-.92.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m178.23 231.07-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m177.629 231.04.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m180.289 231.55-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m179.689 231.52.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m179.27 232.82-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m178.679 232.79.36 2.28-.51-.01.15-2.27Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m180.709 233.94-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m180.109 233.91.36 2.28-.5-.01.14-2.27Zm-3.75-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m177.61 233.81-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m177.009 233.78.37 2.28-.51-.01.14-2.27Zm29.361 51.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m207.611 284.84-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m207.02 284.81.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m209.67 285.32-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m209.07 285.29.37 2.28-.51-.01.14-2.27Zm-1.66 1.31.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m208.661 286.58-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m208.06 286.55.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m210.09 287.7-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m209.49 287.67.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m206.991 287.57-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m206.39 287.54.37 2.28-.51-.01.14-2.27Zm2.12 22.04.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m209.76 309.56-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m209.16 309.52.37 2.29-.51-.02.14-2.27Zm1.409.54.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m211.81 310.04-.05 2.27-.5-.02.55-2.25Z" fill="#87AC57" />
      <path
        d="m211.219 310.01.36 2.28-.51-.02.15-2.26Zm-1.659 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m210.799 311.3-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m210.21 311.27.36 2.28-.51-.01.15-2.27Zm.779 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m212.23 312.42-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m211.639 312.39.36 2.28-.51-.01.15-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m209.14 312.29-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m208.539 312.26.36 2.28-.5-.01.14-2.27Zm4.961-21.62.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m214.75 290.61-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m214.15 290.58.36 2.28-.5-.01.14-2.27Zm1.4.54.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m216.8 291.09-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m216.2 291.06.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m215.79 292.36-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m215.19 292.33.37 2.28-.51-.01.14-2.27Zm.78 1.17.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m217.22 293.48-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m216.619 293.45.371 2.28-.511-.01.14-2.27Zm-3.739-.08.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m214.12 293.34-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m213.53 293.31.36 2.28-.51-.01.15-2.27ZM225 275.18l.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m226.24 275.16-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m225.65 275.13.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m228.3 275.64-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m227.7 275.61.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m227.29 276.9-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m226.69 276.87.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m228.72 278.02-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m228.119 277.99.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m225.621 277.89-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m225.02 277.86.37 2.28-.51-.01.14-2.27Zm19.42 23.93.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m245.691 301.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m245.09 301.74.37 2.28-.51-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m247.74 302.25-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m247.15 302.22.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m246.73 303.51-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m246.14 303.48.36 2.28-.51-.01.15-2.27Zm.78 1.18.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m248.16 304.63-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m247.57 304.6.36 2.28-.51-.01.15-2.27Zm-3.75-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m245.071 304.5-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m244.47 304.47.36 2.28-.5-.01.14-2.27Zm19.35-7.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m265.071 297.14-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m264.47 297.11.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m267.121 297.62-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m266.52 297.59.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m266.111 298.88-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m265.51 298.85.37 2.29-.51-.02.14-2.27Zm.78 1.18.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m267.54 300.01-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m266.94 299.98.37 2.28-.51-.02.14-2.26Zm-3.74-.08.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m264.44 299.87-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m263.85 299.84.36 2.28-.51-.01.15-2.27Zm2.04 8.77.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m267.14 308.59-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m266.539 308.56.36 2.28-.5-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m269.189 309.07-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m268.599 309.04.36 2.28-.51-.01.15-2.27Zm-1.669 1.32.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m268.18 310.33-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m267.579 310.3.37 2.28-.51-.01.14-2.27Zm.79 1.18.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m269.609 311.45-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m269.019 311.42.36 2.28-.51-.01.15-2.27Zm-3.749-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m266.51 311.32-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m265.92 311.29.36 2.28-.51-.01.15-2.27ZM125.3 295.08l.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m126.55 295.06-.06 2.27-.5-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m125.95 295.03.36 2.28-.5-.02.14-2.26Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m128.6 295.54-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m127.999 295.51.37 2.28-.51-.01.14-2.27Zm-1.659 1.31.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m127.59 296.8-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m126.99 296.77.37 2.28-.51-.01.14-2.27Zm.78 1.17.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m129.02 297.92-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m128.419 297.89.37 2.28-.51-.01.14-2.27Zm-3.739-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m125.919 297.79-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m125.33 297.76.36 2.28-.51-.01.15-2.27Zm9.02-2.13.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m135.6 295.61-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m134.999 295.58.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m137.65 296.09-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m137.049 296.06.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m136.64 297.35-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m136.039 297.32.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m138.07 298.47-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m137.469 298.44.37 2.28-.51-.01.14-2.27Zm-3.74-.07.901 2.23-.5.03-.401-2.26Z"
        fill="#87AC57"
      />
      <path d="m134.969 298.34-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m134.38 298.31.36 2.28-.511-.01.151-2.27Zm55.729.66.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m191.349 298.94-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m190.759 298.91.36 2.28-.51-.01.15-2.27Zm1.4.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m193.41 299.42-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m192.809 299.39.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m192.4 300.69-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m191.799 300.66.36 2.28-.5-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m193.83 301.81-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m193.229 301.78.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m190.73 301.68-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m190.129 301.65.37 2.28-.51-.02.14-2.26Zm-3.949 3.97.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m187.43 305.59-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m186.829 305.56.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m189.479 306.07-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m188.889 306.04.36 2.28-.51-.01.15-2.27Zm-1.669 1.32.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m188.47 307.34-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m187.869 307.31.371 2.28-.511-.01.14-2.27Zm.79 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m189.899 308.46-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m189.309 308.43.36 2.28-.51-.01.15-2.27Zm-3.749-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m186.8 308.33-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m186.21 308.3.36 2.28-.51-.01.15-2.27Zm7.72-2.26.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m195.169 306.02-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m194.58 305.99.36 2.28-.51-.02.15-2.26Zm1.399.53.91 2.24-.509.03-.401-2.27Z"
        fill="#87AC57"
      />
      <path d="m197.23 306.5-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m196.629 306.47.36 2.28-.5-.01.14-2.27Zm-1.659 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m196.22 307.76-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m195.619 307.73.36 2.28-.5-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m197.65 308.88-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m197.049 308.85.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m194.55 308.75-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m193.95 308.72.37 2.28-.51-.01.14-2.27Zm31.34 1.49.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m226.54 310.19-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m225.94 310.16.37 2.28-.51-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m228.59 310.67-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m228 310.64.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m227.58 311.93-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m226.99 311.9.36 2.28-.51-.01.15-2.27Zm.78 1.18.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m229.01 313.05-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m228.42 313.02.36 2.28-.51-.01.15-2.27Zm-3.75-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m225.92 312.92-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m225.32 312.89.36 2.28-.5-.01.14-2.27Zm-96.67-10.97.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m129.901 301.9-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m129.3 301.87.37 2.28-.51-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m131.95 302.38-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m131.36 302.35.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m130.94 303.64-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m130.35 303.61.36 2.28-.51-.01.15-2.27Zm.78 1.18.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m132.37 304.76-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m131.78 304.73.36 2.29-.51-.02.15-2.27Zm-3.75-.07.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m129.281 304.63-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path d="m128.68 304.6.36 2.28-.5-.01.14-2.27Z" fill="#87AC57" />
      <path
        d="M208.49 143.28c-14.71-2.4-28.9 26.77-34.15 41.66 13.14 3.38 43.83 14.26 60.05 20.27 1.13-18.01-7.51-58.92-25.89-61.92l-.01-.01Z"
        fill="#C5D8AD"
      />
      <path
        d="M251.789 138.07c-19.46-3.17-38.23 35.29-45.18 54.91 17.38 4.45 57.99 18.8 79.43 26.71 1.49-23.75-9.93-77.67-34.25-81.63v.01Z"
        fill="#C5D8AD"
      />
      <path
        d="M323.479 131.51h-.01a2.15 2.15 0 0 0-2.15 2.15v3.75a2.15 2.15 0 0 0 2.15 2.15h.01a2.15 2.15 0 0 0 2.15-2.15v-3.75a2.15 2.15 0 0 0-2.15-2.15Z"
        fill="#D82F27"
      />
      <path
        d="M323.669 134.48h-.39a1.96 1.96 0 0 0-1.96 1.96v1.16a1.96 1.96 0 0 0 1.96 1.96h.39a1.96 1.96 0 0 0 1.96-1.96v-1.16a1.96 1.96 0 0 0-1.96-1.96Z"
        fill="#fff"
      />
      <path
        d="M323.599 113.45h-.24a.62.62 0 0 0-.62.62v17.99c0 .342.278.62.62.62h.24a.62.62 0 0 0 .62-.62v-17.99a.62.62 0 0 0-.62-.62Z"
        fill="#D82F27"
      />
      <path
        d="M324.219 114.19a.74.74 0 1 0-1.48 0v2.12a.74.74 0 0 0 1.48 0v-2.12Z"
        fill="#D82F27"
      />
      <path
        d="M323.53 106.18h-.11a.2.2 0 0 0-.2.2v9.79a.2.2 0 0 0 .2.2h.11a.2.2 0 0 0 .2-.2v-9.79a.2.2 0 0 0-.2-.2Zm-4.73 74.22s-.07.55-.19 1.47c-.58 4.36-1.76 16.54-2.96 19.25-1.45 3.28-8.84 14.54-8.84 14.54s.36 1.39 2 .57c1.64-.82 5.56-9.84 10.58-9.37 5.02.47 5.02 2.93 5.37 4.57.35 1.64 3.28 11.02 4.22 11.73.94.71 2.16.7 3.05-.47.89-1.17-3.28-14.66 0-15.95 3.28-1.29 6.4 10.12 10.67 9.62 1.99-.23-6.45-11.73-6.45-11.73s-5.79-9.65-6.26-15.39c-.47-5.75-1-11.64-1-11.64h-10.3"
        fill="#D82F27"
      />
      <path
        d="M324.66 138.94h-2.36v3.17h2.36v-3.17Zm-.441-22.02a.74.74 0 1 0-1.48 0v8.01a.74.74 0 0 0 1.48 0v-8.01Z"
        fill="#fff"
      />
      <path
        d="M323.539 124.8h-.12a.68.68 0 0 0-.68.68V132c0 .376.305.68.68.68h.12a.68.68 0 0 0 .68-.68v-6.52a.68.68 0 0 0-.68-.68Z"
        fill="#D82F27"
      />
      <path
        d="M326.349 142.96c-.04-.84-.49-1.18-1.52-1.5l-.12-.02c-.81-.2-1.66-.2-2.47 0l-.12.03c-.89.3-1.48.66-1.52 1.5l-.48 12.41h6.73l-.48-12.41-.02-.01Zm-7.249 31.38h8.76c1.13 0 2.05.92 2.05 2.05v1.66c0 .89-.72 1.61-1.61 1.61h-9.65c-.89 0-1.61-.72-1.61-1.61v-1.66c0-1.13.92-2.05 2.05-2.05h.01Z"
        fill="#fff"
      />
      <path
        d="M326.459 145.44c-.04-.84-.51-1.18-1.57-1.5l-.13-.02c-.84-.2-1.72-.2-2.56 0l-.13.03c-.92.3-1.53.66-1.57 1.5l-.5 12.41h6.95l-.5-12.41.01-.01Z"
        fill="#D82F27"
      />
      <path
        d="M326.959 155.45c-.05-.84-.59-1.18-1.84-1.5l-.15-.02c-.98-.2-2-.2-2.99 0l-.15.03c-1.07.3-1.79.66-1.84 1.5l-.58 12.41h8.12l-.58-12.41.01-.01Z"
        fill="#fff"
      />
      <path
        d="M327.349 164.31c-.06-.75-.66-1.05-2.05-1.34l-.17-.02c-1.09-.17-2.23-.18-3.32 0l-.17.03c-1.2.27-1.99.59-2.05 1.34l-.64 11.02h9.03l-.64-11.02.01-.01Z"
        fill="#D82F27"
      />
      <path d="m263.23 224.61-13.26-4.16v-65.89l13.26-4.07v74.12Z" fill="#EFEFEF" />
      <path d="m280.319 223.76-17.09.85v-74.12l17.09.81v72.46Z" fill="#EFEFEF" />
      <path
        d="m254.48 156.75-2.81.74v-1.81l2.81-.79v1.86Zm3.42-.88-2.98.78v-1.86l2.98-.83v1.91Zm3.64-.96-3.17.83v-1.92l3.17-.88v1.97Zm-7.06 4.47-2.81.68v-1.81l2.81-.72v1.85Zm3.42-.8-2.98.72v-1.86l2.98-.77v1.91Zm3.64-.87-3.17.76v-1.92l3.17-.81v1.97Zm-7.06 4.31-2.81.61v-1.81l2.81-.65v1.85Zm3.42-.72-2.98.64v-1.86l2.98-.69v1.91Zm3.64-.79-3.17.69v-1.92l3.17-.74v1.97Zm-7.06 4.15-2.81.54v-1.81l2.81-.58v1.85Zm3.42-.64-2.98.57v-1.86l2.98-.62v1.91Zm3.64-.71-3.17.62v-1.92l3.17-.66v1.96Zm-7.06 3.99-2.81.47v-1.8l2.81-.53v1.86Zm3.42-.57-2.98.51v-1.86l2.98-.55v1.9Zm3.64-.61-3.17.53v-1.91l3.17-.59v1.97Zm-7.06 3.81-2.81.41v-1.8l2.81-.46v1.85Zm3.42-.48-2.98.44v-1.86l2.98-.49v1.91Zm3.64-.53-3.17.46v-1.91l3.17-.52v1.97Zm-7.06 3.65-2.81.34v-1.8l2.81-.39v1.85Zm3.42-.4-2.98.36v-1.86l2.98-.41v1.91Zm3.64-.45-3.17.39v-1.92l3.17-.44v1.97Zm-7.06 3.49-2.81.28v-1.81l2.81-.33v1.86Zm3.42-.32-2.98.29v-1.86l2.98-.34v1.91Zm3.64-.37-3.17.32v-1.92l3.17-.36v1.96Zm-7.06 3.32-2.81.22v-1.81l2.81-.26v1.85Zm3.42-.24-2.98.23v-1.86l2.98-.28v1.91Zm3.64-.27-3.17.24v-1.92l3.17-.29v1.97Zm-7.06 3.15-2.81.15v-1.81l2.81-.19v1.85Zm3.42-.16-2.98.16v-1.86l2.98-.21v1.91Zm3.64-.19-3.17.17v-1.92l3.17-.22v1.97Zm-7.06 2.99-2.81.08v-1.81l2.81-.13v1.86Zm3.42-.08-2.98.08v-1.86l2.98-.13v1.91Zm3.64-.11-3.17.09v-1.91l3.17-.15v1.97Zm-7.06 2.82-2.81.02v-1.81l2.81-.06v1.85Zm3.42.01-2.98.01v-1.86l2.98-.06v1.91Zm3.64-.03-3.17.02v-1.91l3.17-.07v1.96Zm-7.06 2.66-2.81-.05v-1.8h2.81v1.85Zm3.42.08-2.98-.05v-1.86h2.98v1.91Zm3.64.07-3.17-.06v-1.92l3.17.01v1.97Zm-7.06 2.49-2.81-.12v-1.8l2.81.07v1.85Zm3.42.16-2.98-.12v-1.86l2.98.07v1.91Zm3.64.15-3.17-.13v-1.92l3.17.08v1.97Zm-7.06 2.33-2.81-.19v-1.8l2.81.13v1.86Zm3.42.24-2.98-.2v-1.86l2.98.15v1.91Zm3.64.23-3.17-.2v-1.92l3.17.15v1.97Zm-7.06 2.16-2.81-.24v-1.81l2.81.2v1.85Zm3.42.32-2.98-.26v-1.86l2.98.21v1.91Zm3.64.32-3.17-.27v-1.92l3.17.23v1.96Zm-7.06 2-2.81-.31v-1.81l2.81.27v1.85Zm3.42.4-2.98-.33v-1.86l2.98.28v1.91Zm3.64.41-3.17-.36v-1.91l3.17.3v1.97Zm-7.06 1.83-2.81-.38v-1.81l2.81.33v1.86Zm3.42.48-2.98-.4v-1.86l2.98.35v1.91Zm3.64.49-3.17-.43v-1.92l3.17.38v1.97Zm-7.06 1.66-2.81-.44v-1.81l2.81.4v1.85Zm3.42.57-2.98-.48v-1.86l2.98.43v1.91Zm3.64.57-3.17-.5v-1.92l3.17.45v1.97Zm-7.06 1.5-2.81-.51v-1.81l2.81.47v1.85Zm3.42.64-2.98-.54v-1.86l2.98.49v1.91Zm3.64.66-3.17-.57v-1.92l3.17.52v1.97Zm-7.06 1.34-2.81-.58v-1.8l2.81.53v1.85Zm3.42.72-2.98-.61v-1.86l2.98.56v1.91Zm3.64.75-3.17-.65v-1.92l3.17.6v1.97Zm-7.06 1.17-2.81-.65v-1.8l2.81.59v1.86Zm3.42.8-2.98-.68v-1.86l2.98.63v1.91Zm3.64.83-3.17-.72v-1.92l3.17.67v1.97Zm-7.06 1-2.81-.71v-1.8l2.81.66v1.85Zm3.42.88-2.98-.75v-1.86l2.98.71v1.9Zm3.64.92-3.17-.8v-1.91l3.17.74v1.97Zm-7.06.84-2.81-.77v-1.81l2.81.73v1.85Zm3.42.96-2.98-.82v-1.86l2.98.77v1.91Zm3.64 1-3.17-.87v-1.92l3.17.82v1.97Zm-7.06.68-2.81-.84v-1.81l2.81.79v1.86Zm3.42 1.04-2.98-.89v-1.86l2.98.84v1.91Zm3.64 1.09-3.17-.95v-1.92l3.17.9v1.97Zm7.67-67.42-4.38-.18v-1.99l4.38.2v1.97Zm4.99.23-4.32-.18v-1.97l4.32.2v1.95Zm4.93.21-4.27-.18v-1.96l4.27.2v1.94Zm-9.92 2.36-4.38-.16v-1.99l4.38.18v1.97Zm4.99.22-4.32-.17v-1.97l4.32.18v1.96Zm4.93.19-4.27-.17v-1.95l4.27.17v1.95Zm-9.92 2.4-4.38-.15v-1.99l4.38.17v1.97Zm4.99.19-4.32-.15v-1.97l4.32.17v1.95Zm4.93.17-4.27-.14v-1.96l4.27.16v1.94Zm-9.92 2.44-4.38-.13v-1.99l4.38.15v1.97Zm4.99.18-4.32-.14v-1.96l4.32.14v1.96Zm4.93.15-4.27-.13v-1.96l4.27.15v1.94Zm-9.92 2.48-4.38-.12v-1.99l4.38.14v1.97Zm4.99.15-4.32-.11v-1.97l4.32.13v1.95Zm4.93.14-4.27-.12v-1.95l4.27.12v1.95Zm-9.92 2.51-4.38-.1v-1.99l4.38.12v1.97Zm4.99.14-4.32-.1v-1.97l4.32.11v1.96Zm4.93.12-4.27-.1v-1.96l4.27.11v1.95Zm-9.92 2.54-4.38-.08v-1.98l4.38.09v1.97Zm4.99.13-4.32-.09v-1.97l4.32.1v1.96Zm4.93.09-4.27-.08v-1.96l4.27.1v1.94Zm-9.92 2.59-4.38-.07v-1.98l4.38.08v1.97Zm4.99.1-4.32-.07v-1.97l4.32.08v1.96Zm4.93.08-4.27-.07v-1.95l4.27.08v1.94Zm-9.92 2.62-4.38-.05v-1.98l4.38.06v1.97Zm4.99.09-4.32-.06v-1.97l4.32.07v1.96Zm4.93.06-4.27-.06v-1.95l4.27.06v1.95Zm-9.92 2.66-4.38-.04v-1.98l4.38.05v1.97Zm4.99.06-4.32-.04v-1.97l4.32.05v1.96Zm4.93.05-4.27-.04v-1.96l4.27.05v1.95Zm-9.92 2.69-4.38-.02v-1.98l4.38.03v1.97Zm4.99.05-4.32-.03v-1.96l4.32.03v1.96Zm4.93.02-4.27-.02v-1.96l4.27.04v1.94Zm-9.92 2.73h-4.38v-1.98l4.38.01v1.97Zm4.99.03h-4.32v-1.97l4.32.02v1.95Zm4.93.01-4.27-.01v-1.95l4.27.02v1.94Zm-9.92 2.77-4.38.01v-1.98h4.38v1.97Zm4.99.01-4.32.01v-1.97h4.32v1.96Zm4.93-.01-4.27.01v-1.96h4.27v1.95Zm-9.92 2.8-4.38.03v-1.98l4.38-.02v1.97Zm4.99-.01-4.32.03v-1.97l4.32-.01v1.95Zm4.93-.03-4.27.03v-1.96l4.27-.01v1.94Zm-9.92 2.85-4.38.04v-1.98l4.38-.03v1.97Zm4.99-.03-4.32.04v-1.97l4.32-.03v1.96Zm4.93-.05-4.27.04v-1.95l4.27-.03v1.94Zm-9.92 2.88-4.38.06v-1.98l4.38-.05v1.97Zm4.99-.05-4.32.06v-1.97l4.32-.04v1.95Zm4.93-.06-4.27.06v-1.96l4.27-.05v1.95Zm-9.92 2.91-4.38.08v-1.98l4.38-.07v1.97Zm4.99-.06-4.32.07v-1.96l4.32-.07v1.96Zm4.93-.08-4.27.07v-1.96l4.27-.06v1.95Zm-9.92 2.95-4.38.09v-1.98l4.38-.08v1.97Zm4.99-.08-4.32.09v-1.97l4.32-.08v1.96Zm4.93-.11-4.27.09v-1.95l4.27-.08v1.94Zm-9.92 2.99-4.38.11v-1.98l4.38-.1v1.97Zm4.99-.1-4.32.11v-1.97l4.32-.1v1.96Zm4.93-.12-4.27.1v-1.95l4.27-.09V205Zm-9.92 3.03-4.38.12v-1.98l4.38-.11v1.97Zm4.99-.12-4.32.12v-1.97l4.32-.11v1.96Zm4.93-.14-4.27.12v-1.96l4.27-.11v1.95Zm-9.92 3.06-4.38.14v-1.98l4.38-.13v1.97Zm4.99-.14-4.32.14v-1.97l4.32-.13v1.96Zm4.93-.16-4.27.14v-1.95l4.27-.13v1.94Zm-9.92 3.1-4.38.16v-1.98l4.38-.15v1.97Zm4.99-.15-4.32.15v-1.97l4.32-.14v1.96Zm4.93-.18-4.27.15v-1.95l4.27-.14v1.94Zm-9.92 3.14-4.38.17v-1.98l4.38-.16v1.97Zm4.99-.18-4.32.17v-1.97l4.32-.15v1.95Zm4.93-.19-4.27.17v-1.96l4.27-.16v1.95Zm-9.92 3.17-4.38.19v-1.98l4.38-.18v1.97Zm4.99-.19-4.32.18v-1.96l4.32-.18v1.96Zm4.93-.21-4.27.18v-1.96l4.27-.17v1.95Zm-9.92 3.21-4.38.2v-1.98l4.38-.19v1.97Zm4.99-.22-4.32.21v-1.97l4.32-.19v1.95Zm4.93-.23-4.27.2v-1.95l4.27-.19v1.94Z"
        fill="#A3CDE3"
      />
      <path
        d="m313.81 226.86-16.71.86v-87.56l16.71 1.12v85.58Zm-16.71.89-12.34-3.24v-80.18l12.34-4.17v87.59Z"
        fill="#EFEFEF"
      />
      <path
        d="m302.98 144.43-4.27-.25v-2.37l4.27.27v2.35Zm4.86.31-4.21-.25v-2.35l4.21.27v2.33Zm4.8.29-4.16-.25v-2.33l4.16.25v2.33Zm-9.66 2.75-4.27-.23v-2.37l4.27.25v2.35Zm4.86.29-4.21-.23v-2.35l4.21.24v2.34Zm4.8.26-4.16-.23v-2.33l4.16.24v2.32Zm-9.66 2.8-4.27-.21v-2.37l4.27.23v2.35Zm4.86.26-4.21-.2v-2.36l4.21.23v2.33Zm4.8.24-4.16-.2v-2.34l4.16.22v2.32Zm-9.66 2.85-4.27-.2v-2.36l4.27.2v2.36Zm4.86.24-4.21-.19v-2.35l4.21.2v2.34Zm4.8.22-4.16-.19v-2.34l4.16.2v2.33Zm-9.66 2.88-4.27-.17v-2.36l4.27.18v2.35Zm4.86.23-4.21-.17v-2.36l4.21.19v2.34Zm4.8.19-4.16-.17v-2.33l4.16.18v2.32Zm-9.66 2.93-4.27-.15v-2.37l4.27.17v2.35Zm4.86.2-4.21-.15v-2.35l4.21.16v2.34Zm4.8.17-4.16-.15v-2.33l4.16.16v2.32Zm-9.66 2.98-4.27-.13v-2.37l4.27.15v2.35Zm4.86.18-4.21-.13v-2.36l4.21.15v2.34Zm4.8.15-4.16-.13v-2.34l4.16.14v2.33Zm-9.66 3.02-4.27-.11v-2.37l4.27.13v2.35Zm4.86.15-4.21-.11v-2.35l4.21.13v2.33Zm4.8.13-4.16-.11v-2.34l4.16.13v2.32Zm-9.66 3.07-4.27-.1v-2.36l4.27.1v2.36Zm4.86.13-4.21-.09v-2.35l4.21.1v2.34Zm4.8.1-4.16-.09v-2.33l4.16.1v2.32Zm-9.66 3.11-4.27-.07v-2.37l4.27.09v2.35Zm4.86.11-4.21-.07v-2.35l4.21.09v2.33Zm4.8.09-4.16-.08v-2.33l4.16.08v2.33Zm-9.66 3.15-4.27-.05v-2.37l4.27.07v2.35Zm4.86.09-4.21-.05v-2.35l4.21.06V178Zm4.8.06-4.16-.05v-2.34l4.16.07v2.32Zm-9.66 3.2-4.27-.03v-2.37l4.27.05v2.35Zm4.86.06-4.21-.03v-2.35l4.21.05v2.33Zm4.8.04-4.16-.03v-2.34l4.16.05v2.32Zm-9.66 3.25-4.27-.01v-2.37l4.27.03v2.35Zm4.86.04-4.21-.01v-2.35l4.21.02v2.34Zm4.8.02-4.16-.02v-2.33l4.16.02v2.33Zm-9.66 3.29h-4.27v-2.36h4.27v2.36Zm4.86.02h-4.21v-2.35l4.21.01v2.34Zm4.8-.01h-4.16v-2.33l4.16.01v2.32Zm-9.66 3.34-4.27.02v-2.37l4.27-.01v2.36Zm4.86-.01-4.21.03v-2.35l4.21-.02v2.34Zm4.8-.03-4.16.03v-2.34l4.16-.01v2.32Zm-9.66 3.38-4.27.05v-2.37l4.27-.03v2.35Zm4.86-.02-4.21.04v-2.35l4.21-.03v2.34Zm4.8-.05-4.16.04v-2.33l4.16-.04v2.33Zm-9.66 3.42-4.27.07v-2.37l4.27-.05V198Zm4.86-.05-4.21.07v-2.35l4.21-.05v2.33Zm4.8-.07-4.16.06v-2.33l4.16-.05v2.32Zm-9.66 3.47-4.27.08v-2.36l4.27-.07v2.35Zm4.86-.07-4.21.08v-2.35l4.21-.07v2.34Zm4.8-.1-4.16.09v-2.34l4.16-.07v2.32Zm-9.66 3.52-4.27.1v-2.36l4.27-.09v2.35Zm4.86-.1-4.21.11v-2.35l4.21-.09v2.33Zm4.8-.11-4.16.1v-2.34l4.16-.09v2.33Zm-9.66 3.56-4.27.12v-2.37l4.27-.11v2.36Zm4.86-.12-4.21.12v-2.35l4.21-.11v2.34Zm4.8-.14-4.16.12v-2.33l4.16-.11v2.32Zm-9.66 3.6-4.27.15v-2.37l4.27-.13v2.35Zm4.86-.14-4.21.15v-2.35l4.21-.13v2.33Zm4.8-.16-4.16.14v-2.33l4.16-.13v2.32Zm-9.66 3.65-4.27.17v-2.37l4.27-.15v2.35Zm4.86-.16-4.21.16v-2.35l4.21-.15v2.34Zm4.8-.18-4.16.16v-2.34l4.16-.15v2.33Zm-9.66 3.69-4.27.18v-2.36l4.27-.17v2.35Zm4.86-.18-4.21.18v-2.35l4.21-.17v2.34Zm4.8-.21-4.16.18v-2.34l4.16-.16v2.32Zm-9.66 3.74-4.27.2v-2.36l4.27-.19v2.35Zm4.86-.21-4.21.2v-2.35l4.21-.19v2.34Zm4.8-.23-4.16.2v-2.33l4.16-.19V221Zm-9.66 3.79-4.27.22v-2.37l4.27-.21v2.36Zm4.86-.23-4.21.22v-2.35l4.21-.21v2.34Zm4.8-.25-4.16.21v-2.33l4.16-.21v2.33Zm-23.79-77.75-2.85.79v-2.18l2.85-.84v2.23Zm3.43-.93-2.99.83v-2.23l2.99-.88v2.28Zm3.59-1-3.12.87v-2.29l3.12-.91v2.33Zm-7.02 5.1-2.85.73v-2.18l2.85-.78v2.23Zm3.43-.85-2.99.76v-2.23l2.99-.81v2.28Zm3.59-.93-3.12.81v-2.29l3.12-.85v2.33Zm-7.02 4.95-2.85.67v-2.18l2.85-.71v2.22Zm3.43-.78-2.99.7v-2.23l2.99-.75v2.28Zm3.59-.84-3.12.73v-2.29l3.12-.78v2.34Zm-7.02 4.8-2.85.6v-2.18l2.85-.65v2.23Zm3.43-.71-2.99.63v-2.23l2.99-.68v2.28Zm3.59-.77-3.12.67v-2.29l3.12-.72v2.34Zm-7.02 4.65-2.85.54v-2.18l2.85-.59v2.23Zm3.43-.64-2.99.57v-2.23l2.99-.62v2.28Zm3.59-.69-3.12.6v-2.29l3.12-.64v2.33Zm-7.02 4.5-2.85.48v-2.18l2.85-.53v2.23Zm3.43-.56-2.99.5v-2.23l2.99-.55v2.28Zm3.59-.62-3.12.54v-2.29l3.12-.58v2.33Zm-7.02 4.35-2.85.42v-2.18l2.85-.47v2.23Zm3.43-.49-2.99.45v-2.24l2.99-.49v2.28Zm3.59-.53-3.12.46v-2.29l3.12-.51v2.34Zm-7.02 4.19-2.85.36v-2.18l2.85-.41v2.23Zm3.43-.41-2.99.38v-2.24l2.99-.42v2.28Zm3.59-.46-3.12.4V166l3.12-.45v2.34Zm-7.02 4.04-2.85.3v-2.18l2.85-.35v2.23Zm3.43-.34-2.99.32v-2.24l2.99-.36v2.28Zm3.59-.38-3.12.33v-2.29l3.12-.37v2.33Zm-7.02 3.89-2.85.24v-2.18l2.85-.29v2.23Zm3.43-.26-2.99.25v-2.24l2.99-.29v2.28Zm3.59-.31-3.12.27v-2.29l3.12-.31v2.33Zm-7.02 3.74-2.85.18v-2.18l2.85-.22v2.22Zm3.43-.19-2.99.19v-2.24l2.99-.23v2.28Zm3.59-.22-3.12.19v-2.29l3.12-.24v2.34Zm-7.02 3.58-2.85.12v-2.18l2.85-.16v2.22Zm3.43-.11-2.99.12v-2.24l2.99-.16v2.28Zm3.59-.15-3.12.13v-2.29l3.12-.18v2.34Zm-7.02 3.44-2.85.05v-2.18l2.85-.1v2.23Zm3.43-.05-2.99.06v-2.23l2.99-.11v2.28Zm3.59-.07-3.12.06v-2.29l3.12-.1v2.33Zm-7.02 3.29-2.85-.01v-2.18l2.85-.04v2.23Zm3.43.03-2.99-.01v-2.23l2.99-.04v2.28Zm3.59 0h-3.12v-2.29l3.12-.04v2.33Zm-7.02 3.14-2.85-.07v-2.18l2.85.02v2.23Zm3.43.1-2.99-.07v-2.23l2.99.02v2.28Zm3.59.08-3.12-.07v-2.28l3.12.02v2.33Zm-7.02 2.99L286 194v-2.18l2.85.08v2.23Zm3.43.18-2.99-.14v-2.23l2.99.09v2.28Zm3.59.16-3.12-.14v-2.29l3.12.09v2.34Zm-7.02 2.83-2.85-.19v-2.18l2.85.14v2.23Zm3.43.25-2.99-.2v-2.23l2.99.15v2.28Zm3.59.24-3.12-.21v-2.28l3.12.15v2.34Zm-7.02 2.68-2.85-.25v-2.18l2.85.2v2.23Zm3.43.33-2.99-.26v-2.24l2.99.22v2.28Zm3.59.31-3.12-.27v-2.29l3.12.23v2.33Zm-7.02 2.53-2.85-.31v-2.18l2.85.27v2.22Zm3.43.4-2.99-.32v-2.24l2.99.28v2.28Zm3.59.39-3.12-.34v-2.28l3.12.29v2.33Zm-7.02 2.38-2.85-.37v-2.18l2.85.33v2.22Zm3.43.48-2.99-.39v-2.24l2.99.35v2.28Zm3.59.47-3.12-.41v-2.29l3.12.36v2.34Zm-7.02 2.23-2.85-.44v-2.18l2.85.39v2.23Zm3.43.54-2.99-.45v-2.24l2.99.41v2.28Zm3.59.55-3.12-.48v-2.28l3.12.42v2.34Zm-7.02 2.08-2.85-.5v-2.18l2.85.45v2.23Zm3.43.62-2.99-.52v-2.24l2.99.48v2.28Zm3.59.62-3.12-.54v-2.29l3.12.5v2.33Zm-7.02 1.93-2.85-.56v-2.18l2.85.51v2.23Zm3.43.69-2.99-.58v-2.24l2.99.54v2.28Zm3.59.7-3.12-.61v-2.28l3.12.56v2.33Zm-7.02 1.78-2.85-.62v-2.18l2.85.57v2.23Zm3.43.77-2.99-.65v-2.23l2.99.6v2.28Zm3.59.78-3.12-.68v-2.29l3.12.63v2.34Zm-7.02 1.62-2.85-.68v-2.18l2.85.63v2.23Zm3.43.84-2.99-.71v-2.23l2.99.66v2.28Zm3.59.86-3.12-.75v-2.28l3.12.69v2.34Z"
        fill="#A3CDE3"
      />
      <path d="m333.03 171.04-12.42 1.02-14.97-.31 11.64-1.07 15.75.36Z" fill="#DCF6FF" />
      <path d="m333.03 171.04-12.42 1.02-14.97-.31 11.64-1.07 15.75.36Z" fill="#DCF6FF" />
      <path d="m317.28 233.58-11.64-3.11v-58.72l11.64-1.07v62.9Z" fill="#C5B097" />
      <path d="m333.029 232.51-15.75 1.04v-62.87l15.75.36v61.47Z" fill="#C5B097" />
      <path
        d="m309.5 174.71-2.74.19v-1.59l2.74-.22v1.62Zm3.26-.22-2.84.2v-1.62l2.84-.23v1.65Zm3.4-.25-2.95.21v-1.65l2.95-.24v1.68Zm-6.66 2.77-2.74.16v-1.59l2.74-.19v1.62Zm3.26-.18-2.84.17v-1.62l2.84-.2v1.65Zm3.4-.2-2.95.18v-1.66l2.95-.2v1.68Zm-6.66 2.68-2.74.13v-1.6l2.74-.15v1.62Zm3.26-.13-2.84.13v-1.62l2.84-.16v1.65Zm3.4-.15-2.95.13v-1.65l2.95-.16v1.68Zm-6.66 2.59-2.74.08v-1.59l2.74-.11v1.62Zm3.26-.09-2.84.09V180l2.84-.12v1.65Zm3.4-.11-2.95.1v-1.66l2.95-.12v1.68Zm-6.66 2.5-2.74.05v-1.6l2.74-.07v1.62Zm3.26-.04-2.84.05v-1.62l2.84-.08v1.65Zm3.4-.06-2.95.05v-1.65l2.95-.08v1.68Zm-6.66 2.4-2.74.01v-1.59l2.74-.04v1.62Zm3.26.01-2.84.01v-1.63l2.84-.03v1.65Zm3.4-.02-2.95.01v-1.65l2.95-.04v1.68Zm-6.66 2.31-2.74-.02v-1.59h2.74v1.61Zm3.26.05-2.84-.02v-1.63h2.84v1.65Zm3.4.04-2.95-.03v-1.66h2.95v1.69Zm-6.66 2.22-2.74-.07v-1.59l2.74.04v1.62Zm3.26.09-2.84-.07v-1.62l2.84.04v1.65Zm3.4.08-2.95-.07v-1.65l2.95.04V191Zm-6.66 2.13-2.74-.1v-1.59l2.74.07v1.62Zm3.26.14-2.84-.11v-1.62l2.84.08v1.65Zm3.4.13-2.95-.11v-1.66l2.95.08v1.69Zm-6.66 2.03-2.74-.14v-1.59l2.74.12v1.61Zm3.26.19-2.84-.15v-1.62l2.84.12v1.65Zm3.4.17-2.95-.15v-1.65l2.95.12v1.68Zm-6.66 1.95-2.74-.18v-1.59l2.74.15v1.62Zm3.26.23-2.84-.19v-1.62l2.84.16v1.65Zm3.4.22-2.95-.2v-1.65l2.95.16v1.69Zm-6.66 1.85-2.74-.21v-1.6l2.74.19v1.62Zm3.26.27-2.84-.22v-1.62l2.84.19v1.65Zm3.4.27-2.95-.23v-1.66l2.95.21v1.68Zm-6.66 1.76-2.74-.25v-1.59l2.74.22v1.62Zm3.26.32-2.84-.26v-1.62l2.84.23v1.65Zm3.4.32-2.95-.28v-1.65l2.95.24v1.69Zm-6.66 1.67-2.74-.29v-1.6l2.74.27v1.62Zm3.26.36-2.84-.3v-1.62l2.84.27v1.65Zm3.4.36-2.95-.31v-1.66l2.95.29v1.68Zm-6.66 1.58-2.74-.33v-1.59l2.74.3v1.62Zm3.26.41-2.84-.34v-1.63l2.84.32v1.65Zm3.4.41-2.95-.36v-1.65l2.95.32v1.69Zm-6.66 1.48-2.74-.36v-1.59l2.74.33v1.62Zm3.26.46-2.84-.38v-1.63l2.84.36v1.65Zm3.4.45-2.95-.39v-1.66l2.95.37v1.68Zm-6.66 1.4-2.74-.41v-1.59l2.74.38v1.62Zm3.26.49-2.84-.41v-1.63l2.84.39v1.65Zm3.4.5-2.95-.43v-1.65l2.95.4v1.68Zm-6.66 1.31-2.74-.44v-1.59l2.74.41v1.62Zm3.26.54-2.84-.46v-1.62l2.84.43v1.65Zm3.4.55-2.95-.48v-1.65l2.95.45v1.68Zm-6.66 1.21-2.74-.48v-1.59l2.74.45v1.62Zm3.26.59-2.84-.5v-1.62l2.84.47v1.65Zm3.4.59-2.95-.51v-1.66l2.95.49v1.68Zm-6.66 1.12-2.74-.51v-1.59l2.74.49v1.61Zm3.26.64-2.84-.54v-1.62l2.84.51v1.65Zm3.4.64-2.95-.56v-1.65l2.95.53v1.68Zm-6.66 1.03-2.74-.56v-1.59l2.74.53v1.62Zm3.26.68-2.84-.58v-1.62l2.84.55v1.65Zm3.4.68-2.95-.59v-1.66l2.95.57v1.68Zm-6.66.94-2.74-.59v-1.59l2.74.56v1.62Zm3.26.72-2.84-.61v-1.62l2.84.58v1.65Zm3.4.74-2.95-.64v-1.65l2.95.61v1.68Zm-6.66.84-2.74-.62v-1.6l2.74.61v1.61Zm3.26.77-2.84-.65v-1.62l2.84.62v1.65Zm3.4.78-2.95-.68v-1.65l2.95.65v1.68Zm-6.66.76-2.74-.67v-1.59l2.74.64v1.62Zm3.26.81-2.84-.69v-1.62l2.84.66v1.65Zm3.4.83-2.95-.72v-1.66l2.95.69v1.69Zm-6.66.66-2.74-.7v-1.6l2.74.68v1.62Zm3.26.86-2.84-.73v-1.63l2.84.71v1.65Zm3.4.87-2.95-.76v-1.65l2.95.73v1.68Zm6.299-57.42-4.27-.07v-1.69l4.27.09v1.67Zm4.86.11-4.21-.08v-1.67l4.21.09v1.66Zm4.79.08-4.15-.07v-1.66l4.15.08v1.65Zm-9.65 2.19-4.27-.06v-1.68l4.27.07v1.67Zm4.86.09-4.21-.06v-1.67l4.21.07v1.66Zm4.79.07-4.15-.06v-1.66l4.15.07v1.65Zm-9.65 2.22-4.27-.04v-1.69l4.27.06v1.67Zm4.86.08-4.21-.05v-1.67l4.21.05v1.67Zm4.79.05-4.15-.05v-1.66l4.15.06v1.65Zm-9.65 2.26-4.27-.04v-1.68l4.27.04v1.68Zm4.86.05-4.21-.03v-1.67l4.21.04v1.66Zm4.79.04-4.15-.03v-1.66l4.15.04v1.65Zm-9.65 2.29-4.27-.02v-1.69l4.27.03v1.68Zm4.86.03-4.21-.01v-1.67l4.21.02v1.66Zm4.79.03-4.15-.02v-1.66l4.15.03v1.65Zm-9.65 2.32-4.27-.01v-1.68l4.27.01v1.68Zm4.86.02h-4.21v-1.68l4.21.02v1.66Zm4.79 0h-4.15v-1.66l4.15.01v1.65Zm-9.65 2.36-4.27.01v-1.68l4.27-.01v1.68Zm4.86 0-4.21.01v-1.67h4.21v1.66Zm4.79-.01-4.15.01v-1.66h4.15v1.65Zm-9.65 2.39-4.27.02v-1.68l4.27-.01v1.67Zm4.86-.01-4.21.02v-1.67l4.21-.01v1.66Zm4.79-.03-4.15.02v-1.66l4.15-.01v1.65Zm-9.65 2.42-4.27.04v-1.68l4.27-.03v1.67Zm4.86-.03-4.21.04v-1.67l4.21-.03v1.66Zm4.79-.04-4.15.04v-1.66l4.15-.03v1.65Zm-9.65 2.45-4.27.05v-1.68l4.27-.04v1.67Zm4.86-.04-4.21.05v-1.67l4.21-.04v1.66Zm4.79-.06-4.15.05v-1.66l4.15-.04v1.65Zm-9.65 2.48-4.27.07v-1.68l4.27-.06v1.67Zm4.86-.06-4.21.07v-1.67l4.21-.06v1.66Zm4.79-.08-4.15.07v-1.66l4.15-.06v1.65Zm-9.65 2.52-4.27.08v-1.68l4.27-.07v1.67Zm4.86-.07-4.21.08v-1.67l4.21-.08v1.67Zm4.79-.1-4.15.08v-1.66l4.15-.07v1.65Zm-9.65 2.55-4.27.1v-1.68l4.27-.09v1.67Zm4.86-.09-4.21.1v-1.68l4.21-.08v1.66Zm4.79-.11-4.15.1v-1.66l4.15-.09v1.65Zm-9.65 2.58-4.27.12v-1.69l4.27-.1v1.67Zm4.86-.11-4.21.11v-1.67l4.21-.1v1.66Zm4.79-.12-4.15.11v-1.66l4.15-.1v1.65Zm-9.65 2.61-4.27.13v-1.68l4.27-.12v1.67Zm4.86-.12-4.21.12v-1.67l4.21-.11v1.66Zm4.79-.14-4.15.12v-1.66l4.15-.11v1.65Zm-9.65 2.65-4.27.14v-1.69l4.27-.13v1.68Zm4.86-.15-4.21.14v-1.67l4.21-.13v1.66Zm4.79-.16-4.15.14v-1.66l4.15-.13v1.65Zm-9.65 2.69-4.27.15v-1.68l4.27-.15v1.68Zm4.86-.16-4.21.15v-1.67l4.21-.14v1.66Zm4.79-.18-4.15.15v-1.66l4.15-.14v1.65Zm-9.65 2.72-4.27.17v-1.69l4.27-.16v1.68Zm4.86-.18-4.21.17v-1.67l4.21-.16v1.66Zm4.79-.19-4.15.17v-1.66l4.15-.16v1.65Zm-9.65 2.75-4.27.18v-1.68l4.27-.18v1.68Zm4.86-.19-4.21.18v-1.67l4.21-.18v1.67Zm4.79-.21-4.15.18v-1.66l4.15-.17v1.65Zm-9.65 2.78-4.27.2v-1.69l4.27-.18v1.67Zm4.86-.21-4.21.2v-1.68l4.21-.18v1.66Zm4.79-.22-4.15.19v-1.66l4.15-.18v1.65Zm-9.65 2.81-4.27.21v-1.68l4.27-.2v1.67Zm4.86-.23-4.21.21v-1.67l4.21-.2v1.66Zm4.79-.23-4.15.2v-1.66l4.15-.19v1.65Zm-9.65 2.84-4.27.23v-1.69l4.27-.21v1.67Zm4.86-.24-4.21.22v-1.67l4.21-.21v1.66Zm4.79-.26-4.15.23v-1.66l4.15-.22v1.65Zm-9.65 2.88-4.27.24v-1.68l4.27-.23v1.67Zm4.86-.26-4.21.24v-1.67l4.21-.23v1.66Zm4.79-.27-4.15.24v-1.66l4.15-.23v1.65Zm-9.65 2.91-4.27.26v-1.68l4.27-.25v1.67Zm4.86-.27-4.21.25v-1.67l4.21-.24v1.66Zm4.79-.29-4.15.25v-1.66l4.15-.24v1.65Zm-9.65 2.94-4.27.27v-1.68l4.27-.26v1.67Zm4.86-.29-4.21.27v-1.67l4.21-.26v1.66Zm4.79-.3-4.15.26v-1.66l4.15-.25v1.65Z"
        fill="#C1E9F4"
      />
      <path d="m345.3 226.84-12.23-2.41v-99.59l12.23-3.96v105.96Z" fill="#F0F0F0" />
      <path
        d="m343.63 126.14-8.88 2.67v-2.63l8.88-2.79v2.75Zm0 3.92-8.88 2.5v-2.63l8.88-2.62v2.75Zm0 3.93-8.88 2.32v-2.63l8.88-2.44v2.75Zm0 3.92-8.88 2.15v-2.62l8.88-2.27v2.74Zm0 3.93-8.88 1.98v-2.63l8.88-2.1v2.75Zm0 3.93-8.88 1.8v-2.63l8.88-1.92v2.75Zm0 3.92-8.88 1.63v-2.62l8.88-1.76v2.75Zm0 3.93-8.88 1.46v-2.63l8.88-1.58v2.75Zm0 3.92-8.88 1.29v-2.63l8.88-1.41v2.75Zm0 3.93-8.88 1.11v-2.63l8.88-1.23v2.75Zm0 3.92-8.88.94v-2.62l8.88-1.06v2.74Zm0 3.93-8.88.77v-2.63l8.88-.89v2.75Zm0 3.93-8.88.59v-2.63l8.88-.71v2.75Zm0 3.92-8.88.42v-2.63l8.88-.54v2.75Zm0 3.93-8.88.25v-2.63l8.88-.37v2.75Zm0 3.92-8.88.08v-2.63l8.88-.19v2.74Zm0 3.93-8.88-.1v-2.63l8.88-.02v2.75Zm0 3.93-8.88-.28v-2.62l8.88.15v2.75Zm0 3.92-8.88-.44v-2.63l8.88.32v2.75Zm0 3.93-8.88-.62v-2.63l8.88.5v2.75Zm0 3.92-8.88-.79v-2.63l8.88.67v2.75Zm0 3.93-8.88-.97v-2.62l8.88.84v2.75Zm0 3.92-8.88-1.13v-2.63l8.88 1.02v2.74Zm0 3.93-8.88-1.31v-2.63l8.88 1.19v2.75Zm0 3.93-8.88-1.49v-2.62l8.88 1.36v2.75Zm0 3.92-8.88-1.65V220l8.88 1.53v2.75Z"
        fill="#A3CDE3"
      />
      <path d="m363.321 225.78-18.02 1.06V120.88l18.02 1.74v103.16Z" fill="#F0F0F0" />
      <path
        d="m361.53 127.09-14.44-1.3v-2.77l14.44 1.36v2.71Zm0 3.87-14.44-1.21v-2.77l14.44 1.27v2.71Zm0 3.88-14.44-1.13v-2.77l14.44 1.19v2.71Zm0 3.88-14.44-1.05v-2.77l14.44 1.1v2.72Zm0 3.87-14.44-.96v-2.77l14.44 1.02v2.71Zm0 3.88-14.44-.88v-2.77l14.44.93v2.72Zm0 3.87-14.44-.79v-2.77l14.44.85v2.71Zm0 3.88-14.44-.71v-2.77l14.44.76v2.72Zm0 3.87-14.44-.62v-2.77l14.44.68v2.71Zm0 3.88-14.44-.54v-2.77l14.44.6v2.71Zm0 3.87-14.44-.45v-2.77l14.44.51v2.71Zm0 3.88-14.44-.37v-2.77l14.44.43v2.71Zm0 3.88-14.44-.29v-2.77l14.44.34v2.72Zm0 3.87-14.44-.2v-2.77l14.44.26v2.71Zm0 3.88-14.44-.12v-2.77l14.44.17v2.72Zm0 3.87-14.44-.03v-2.77l14.44.09v2.71Zm0 3.88-14.44.05v-2.77h14.44v2.72Zm0 3.87-14.44.14v-2.77l14.44-.08v2.71Zm0 3.88-14.44.22v-2.77l14.44-.17v2.72Zm0 3.87-14.44.31v-2.77l14.44-.25v2.71Zm0 3.88-14.44.39v-2.77l14.44-.33v2.71Zm0 3.87-14.44.48v-2.77l14.44-.42v2.71Zm0 3.88-14.44.56v-2.77l14.44-.5v2.71Zm0 3.88-14.44.64v-2.77l14.44-.59v2.72Zm0 3.87-14.44.73v-2.77l14.44-.67v2.71Zm0 3.88-14.44.81v-2.77l14.44-.76v2.72Z"
        fill="#A3CDE3"
      />
      <path
        d="m373.14 241.09-11.61-2.64v-76.19l11.61-1.61v80.44Zm11.071-.93-11.07.93v-80.44l11.07.44v79.07Z"
        fill="#F0F0F0"
      />
      <path
        d="m371.911 164.53-9.15.85v-2.01l9.15-.93v2.09Zm0 2.98-9.15.73v-2.01l9.15-.81v2.09Zm0 2.99-9.15.61v-2.01l9.15-.69v2.09Zm0 2.98-9.15.49v-2l9.15-.58v2.09Zm0 2.98-9.15.38v-2.01l9.15-.45v2.08Zm0 2.99-9.15.25v-2l9.15-.34v2.09Zm0 2.98-9.15.14v-2.01l9.15-.22v2.09Zm0 2.99-9.15.01v-2l9.15-.1v2.09Zm0 2.98-9.15-.1v-2.01l9.15.02v2.09Zm0 2.99-9.15-.22v-2.01l9.15.14v2.09Zm0 2.98-9.15-.34v-2l9.15.25v2.09Zm0 2.98-9.15-.45v-2.01l9.15.37v2.09Zm0 2.99-9.15-.58v-2l9.15.49v2.09Zm0 2.98-9.15-.69v-2.01l9.15.61v2.09Zm0 2.99-9.15-.82v-2l9.15.73v2.09Zm0 2.98-9.15-.93v-2.01l9.15.85v2.09Zm0 2.98-9.15-1.04v-2.01l9.15.96v2.09Zm0 2.99-9.15-1.17v-2l9.15 1.08v2.09Zm0 2.98-9.15-1.28v-2.01l9.15 1.2v2.09Zm0 2.99-9.15-1.41v-2l9.15 1.32v2.09Zm0 2.98-9.15-1.52v-2.01l9.15 1.44v2.09Zm0 2.98-9.15-1.64v-2l9.15 1.55v2.09Zm0 2.99-9.15-1.76v-2.01l9.15 1.68v2.09Zm0 2.98-9.15-1.87v-2.01l9.15 1.79v2.09Zm0 2.99-9.15-2v-2.01l9.15 1.92v2.09Zm0 2.98-9.15-2.11v-2.01l9.15 2.03v2.09Zm11.489-74.07-9.45-.53v-2.1l9.45.58v2.05Zm0 2.94-9.45-.48v-2.1l9.45.52V168Zm0 2.93-9.45-.42v-2.09l9.45.46v2.05Zm0 2.94-9.45-.37v-2.09l9.45.4v2.06Zm0 2.93-9.45-.31v-2.09l9.45.35v2.05Zm0 2.94-9.45-.26v-2.09l9.45.29v2.06Zm0 2.93-9.45-.2v-2.09l9.45.24v2.05Zm0 2.94-9.45-.14v-2.1l9.45.18v2.06Zm0 2.93-9.45-.08v-2.1l9.45.13v2.05Zm0 2.94-9.45-.03v-2.1l9.45.07v2.06Zm0 2.93-9.45.03v-2.1l9.45.02v2.05Zm0 2.94-9.45.08v-2.09l9.45-.05v2.06Zm0 2.94-9.45.13v-2.09l9.45-.1v2.06Zm0 2.93-9.45.19v-2.09l9.45-.15v2.05Zm0 2.94-9.45.24v-2.09l9.45-.21v2.06Zm0 2.93-9.45.3v-2.09l9.45-.26v2.05Zm0 2.94-9.45.36v-2.1l9.45-.32v2.06Zm0 2.93-9.45.42v-2.1l9.45-.37v2.05Zm0 2.94-9.45.47v-2.1l9.45-.43v2.06Zm0 2.93-9.45.53v-2.1l9.45-.48v2.05Zm0 2.94-9.45.58v-2.09l9.45-.55v2.06Zm0 2.93-9.45.64v-2.09l9.45-.6v2.05Zm0 2.94-9.45.69v-2.09l9.45-.66v2.06Zm0 2.93-9.45.75v-2.09l9.45-.71v2.05Zm0 2.94-9.45.8v-2.09l9.45-.77v2.06Zm0 2.93-9.45.87v-2.1l9.45-.82v2.05Z"
        fill="#A3CDE3"
      />
      <path
        d="M141.07 255.76c8.69-6.96 12.15-17.85 8.41-28.41-.89-2.63-2.12-5.2-3.69-7.59-1.49-2.38-3.7-4.73-4.82-7.93-.57-1.48-.55-3.26-.53-4.77.15-4.63-2.02-8.65-6.82-9.62 5.22.35 8.1 4.58 8.6 9.48.21 1.46.28 2.74.96 4.02 1.19 2.38 3.43 4.27 5.48 6.67a37.57 37.57 0 0 1 5.25 7.9c6.43 12.56 3.43 27.05-6.13 37.16l-6.71-6.9v-.01Z"
        fill="#DCF6FF"
      />
      <path
        d="M144.68 259.19c2.42 9.56-5.3 19.67-13.42 24.04-10.52 5.29-22.41 3.32-33.37 1.26-8.42-2.2-16.35 1.64-23.19 6.34l-.35-.35c14.06-14.48 22.24-9.41 39.72-8.86 11.34.57 20.77-2.7 27.1-12.56 1.87-2.93 3.21-6.34 3.02-9.83l.5-.04h-.01Zm9.12 4.57c9.99.47 25.82 6.76 32.45 14.45 4.73 5.19 7.22 12.74 11.89 17.52 3.07 3.14 7.08 4.68 11.53 5.5 6.94 1.27 14.27 2.63 20.96 5.28 6.68 2.66 13.57 6.95 16.45 13.79l-.35.19c-3.97-5.96-10.52-9.06-17.11-11.08-6.78-2.1-13.61-2.92-20.7-4.11-2.39-.41-4.99-1.09-7.29-2.31-11.46-5.71-11.9-21.03-22.11-27.99-7.56-5.3-16.46-9.63-25.72-10.85l.02-.4-.02.01Z"
        fill="#DCF6FF"
      />
      <path d="m190.64 238.7-.76-.73-1.09.07.75.72 1.1-.06Z" fill="#EE6843" />
      <path d="m188.63 258.79-5.61-7.87v-11.23l5.61 6.45v12.65Z" fill="#EFF3F4" />
      <path d="m197.02 258.03-8.39.75v-12.64l8.39-.62v12.51Z" fill="#E1E1E1" />
      <path d="m197.02 245.52-6.22-6.34-7.78.5 5.61 6.46 8.39-.62Z" fill="#CACACA" />
      <path d="m188.63 246.14-5.62-6.46 5.78-1.64.75.72-.91 7.38Z" fill="#EE6843" />
      <path d="m197.02 245.52-8.4.62.92-7.38 1.1-.06 6.38 6.82Z" fill="#DD582B" />
      <path d="m176.34 253.59 2.66 4.77v-4.7l-2.66-4.46v4.39Z" fill="#EFF3F4" />
      <path d="M187.87 250.07v2.92l-8.87.72 8.87-3.64Z" fill="#DD582B" />
      <path d="m179 253.71-2.66-4.51 7.97-3.34 3.56 4.21-8.87 3.64Z" fill="#EE6843" />
      <path
        d="m194.709 249.96-3.77.3v-3.13l3.77-.28v3.11Zm0 4.13-3.77.31v-3.13l3.77-.3v3.12Z"
        fill="#93CEEE"
      />
      <path d="m188.63 258.79-5.61-7.87v-11.23l5.61 6.45v12.65Z" fill="#EFF3F4" />
      <path d="m197.02 258.03-8.39.75v-12.64l8.39-.62v12.51Z" fill="#E1E1E1" />
      <path d="m197.02 245.52-6.22-6.34-7.78.5 5.61 6.46 8.39-.62Z" fill="#CACACA" />
      <path d="m188.63 246.14-5.62-6.46 5.78-1.64.75.72-.91 7.38Z" fill="#EE6843" />
      <path d="m197.02 245.52-8.4.62.92-7.38 1.1-.06 6.38 6.82Z" fill="#DD582B" />
      <path d="m179 258.37 8.84-.62.04-4.76-8.88.72v4.66Z" fill="#E1E1E1" />
      <path d="m176.34 253.59 2.66 4.77v-4.7l-2.66-4.46v4.39Z" fill="#EFF3F4" />
      <path d="M187.87 250.07v2.92l-8.87.72 8.87-3.64Z" fill="#DD582B" />
      <path d="m179 253.71-2.66-4.51 7.97-3.34 3.56 4.21-8.87 3.64Z" fill="#EE6843" />
      <path
        d="m194.709 249.96-3.77.3v-3.13l3.77-.28v3.11Zm0 4.13-3.77.31v-3.13l3.77-.3v3.12Z"
        fill="#93CEEE"
      />
      <path d="m208.021 272.61 2.8 3.83v-4.78l-2.8-3.63v4.58Z" fill="#EFF3F4" />
      <path d="m217.04 264.63 3.17 3.58-9.4 3.44-2.82-3.66 9.05-3.36Z" fill="#EE6843" />
      <path d="m220.23 270.66-9.41.99v4.79l9.41-1.04v-4.74Z" fill="#E1E1E1" />
      <path d="M220.21 268.21v2.44l-9.42.99 9.42-3.43Z" fill="#DD582B" />
      <path d="m217.781 274.51-4.51.49v-2.42l4.51-.48v2.41Z" fill="#93CEEE" />
      <path d="m208.021 272.61 2.8 3.83v-4.78l-2.8-3.63v4.58Z" fill="#EFF3F4" />
      <path d="m217.04 264.63 3.17 3.58-9.4 3.44-2.82-3.66 9.05-3.36Z" fill="#EE6843" />
      <path d="m220.23 270.66-9.41.99v4.79l9.41-1.04v-4.74Z" fill="#E1E1E1" />
      <path d="M220.21 268.21v2.44l-9.42.99 9.42-3.43Z" fill="#DD582B" />
      <path d="m217.781 274.51-4.51.49v-2.42l4.51-.48v2.41Z" fill="#93CEEE" />
      <path d="m247.17 287.71-19.83 2.59 3.37-4.82 13.23-1.65 3.23 3.88Z" fill="#DD582B" />
      <path d="m247.25 296.92-19.83 2.82v-9.44l19.83-2.59v9.21Z" fill="#E1E1E1" />
      <path d="m241.279 281.31 2.66 2.52-13.23 1.65-2.35-2.6 12.92-1.57Z" fill="#EE6843" />
      <path
        d="m231.39 296.3-1.31.18v-3.58l1.31-.17v3.57Zm3.34-.46-1.29.18v-3.57l1.29-.17v3.56Zm3.321-.45-1.28.17v-3.55l1.28-.17v3.55Zm3.28-.45-1.27.17v-3.54l1.27-.17v3.54Zm3.259-.45-1.26.17v-3.52l1.26-.17v3.52Z"
        fill="#93CEEE"
      />
      <path d="m247.17 287.71-19.83 2.59 3.37-4.82 13.23-1.65 3.23 3.88Z" fill="#DD582B" />
      <path d="m247.25 296.92-19.83 2.82v-9.44l19.83-2.59v9.21Z" fill="#E1E1E1" />
      <path d="m227.34 290.3-3.2-3.86 4.22-3.55 2.35 2.59-3.37 4.82Z" fill="#EE6843" />
      <path d="m241.279 281.31 2.66 2.52-13.23 1.65-2.35-2.6 12.92-1.57Z" fill="#EE6843" />
      <path d="m224.14 295.52 3.2 4.22v-9.48l-3.2-3.86v9.12Z" fill="#E1E1E1" />
      <path
        d="m231.39 296.3-1.31.18v-3.58l1.31-.17v3.57Zm3.34-.46-1.29.18v-3.57l1.29-.17v3.56Zm3.321-.45-1.28.17v-3.55l1.28-.17v3.55Zm3.28-.45-1.27.17v-3.54l1.27-.17v3.54Zm3.259-.45-1.26.17v-3.52l1.26-.17v3.52Z"
        fill="#93CEEE"
      />
      <path d="m109.319 252.94-.11 1.41-6.55-.04 6.66-1.37Z" fill="#BE9D73" />
      <path d="m108.319 254.34-5.57 10.33-6.64.03 6.51-10.4 5.7.04Z" fill="#EB1C24" />
      <path d="m108.299 253.16-5.44 10.09-6.75 1.45 6.51-10.4 5.68-1.14Z" fill="#EE6843" />
      <path d="m119.57 253.43-2.92 7.85-13.64.02 4.46-7.97 12.1.1Z" fill="#BE9D73" />
      <path d="m110.439 265.32-1.74.01.19-2.41h1.74l-.19 2.4Z" fill="#91CCEC" />
      <path d="m103.009 269.42-6.9.07v-4.79l6.9-.03v4.75Z" fill="#EFF3F4" />
      <path
        d="m102.859 263.25-.12 1.42-6.63.03 6.75-1.45Zm13.821-1.97-13.67.02 6.48-4.82 1.6.01 5.59 4.79Z"
        fill="#DD582B"
      />
      <path d="m111.089 256.49 3.11-6.49-1.44-.02-3.28 6.5 1.61.01Z" fill="#EE6843" />
      <path d="m116.65 261.28-5.56-4.79 3.11-6.49 5.37 3.43-2.92 7.85Z" fill="#DD582B" />
      <path d="m103.01 261.3 6.48-4.82 3.27-6.5-5.29 3.35-4.46 7.97Z" fill="#EE6843" />
      <path d="m109.319 252.94-.11 1.41-6.55-.04 6.66-1.37Z" fill="#BE9D73" />
      <path d="m108.319 254.34-5.57 10.33-6.64.03 6.51-10.4 5.7.04Z" fill="#EB1C24" />
      <path d="m108.309 253.16-5.29 10.06-6.91 1.48 6.52-10.4 5.68-1.14Z" fill="#EE6843" />
      <path d="m119.57 253.43-2.92 7.85-13.64.02 4.46-7.97 12.1.1Z" fill="#BE9D73" />
      <path d="m116.65 269.29-13.64.13v-8.15l13.64.01v8.01Z" fill="#EFF3F4" />
      <path d="m110.63 265.32-1.74.03v-2.43h1.74v2.4Z" fill="#91CCEC" />
      <path
        d="M103.009 263.22v1.45l-6.9.03 6.9-1.48Zm13.641-1.94-13.64.02 6.48-4.82 1.6.01 5.56 4.79Z"
        fill="#DD582B"
      />
      <path d="m111.089 256.49 3.11-6.49-1.44-.02-3.28 6.5 1.61.01Z" fill="#EE6843" />
      <path d="m116.65 261.28-5.56-4.79 3.11-6.49 5.37 3.43-2.92 7.85Z" fill="#DD582B" />
      <path d="m103.01 261.3 6.48-4.82 3.27-6.5-5.29 3.35-4.46 7.97Z" fill="#EE6843" />
      <path
        d="m118.869 262.1-2.22 7.19v-8.01l2.92-7.85-.7 8.67Zm46.741 37.83-7.69 1.02v-5.01l7.69-.98v4.97Z"
        fill="#E1E1E1"
      />
      <path d="m161.78 290.62-3.86 5.32 7.69-.98-3.83-4.34Z" fill="#DD582B" />
      <path d="m157.91 300.97-1.8-10.69-.05-4.75 1.85 10.34v5.1Z" fill="#EFF3F4" />
      <path d="m159.65 280.63-3.59 4.9 7.15-.82-3.56-4.08Z" fill="#BE9D73" />
      <path d="m165.679 295.06-2.47-10.35-3.56-4.08 2.16 10.14 3.87 4.29Z" fill="#DD582B" />
      <path d="m162.529 299.37-1.54.21v-3.04l1.54-.2v3.03Z" fill="#93CEEE" />
      <path d="m157.91 295.94-1.85-10.41 3.59-4.9 2.13 9.99-3.87 5.32Z" fill="#EE6843" />
      <path d="m165.61 299.93-7.69 1.02v-5.01l7.69-.98v4.97Z" fill="#E1E1E1" />
      <path d="m161.78 290.62-3.86 5.32 7.69-.98-3.83-4.34Z" fill="#DD582B" />
      <path d="m157.91 300.97-1.8-10.69-.05-4.75 1.85 10.34v5.1Z" fill="#EFF3F4" />
      <path d="m159.65 280.63-3.59 4.9 7.15-.82-3.56-4.08Z" fill="#BE9D73" />
      <path d="m165.679 295.06-2.47-10.35-3.56-4.08 2.16 10.14 3.87 4.29Z" fill="#DD582B" />
      <path d="m162.529 299.37-1.54.21v-3.04l1.54-.2v3.03Z" fill="#93CEEE" />
      <path d="m157.91 295.94-1.85-10.41 3.59-4.9 2.13 9.99-3.87 5.32Z" fill="#EE6843" />
      <path
        d="M128.17 258.66c-.12-1.52.45-2.73 1.66-3.66.48-.37 1.22-1.18 1.27-2.1.08-1.48 2.22-2.63 4.04-3.3.82-.3 2-.61 2.87-.71 3.9-.45 4.78.05 6.93.58 2.35.57 3.08 1.21 5.47.52 2.39-.69 2.72.04 6.32-.11s5.12-.53 7.69.62c2.56 1.15 1.73 1.93 2.59 3.84.86 1.91 2.1 1.25 2.75 3.81.65 2.56-1.44 4.77-4.33 5.84-2.9 1.07-5.14.86-7.42.48-2.28-.38-4.54.11-6.13.45-1.59.34-5.12-.84-6.34-.71-1.22.13-4 .9-5.97 1.1-1.97.2-6.41.1-8.5-1.65-1.36-1.14-2.73-2.96-2.89-5h-.01Z"
        fill="#DCF6FF"
      />
      <path
        d="M157.279 266.78c.575 0 1.04-.569 1.04-1.27 0-.701-.465-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M158.74 266.41c.491 0 .89-.488.89-1.09 0-.602-.399-1.09-.89-1.09-.492 0-.89.488-.89 1.09 0 .602.398 1.09.89 1.09Zm-2.53 1.24c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M157.329 268.19c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M158.579 268.19c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M159.52 267.65c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm-8.64-1.28c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.575 0-1.04.569-1.04 1.27 0 .701.465 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M152.34 266.01c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.53 1.23c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M150.93 267.79c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M152.18 267.79c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M153.12 267.24c.63 0 1.14-.542 1.14-1.21 0-.668-.51-1.21-1.14-1.21-.629 0-1.14.542-1.14 1.21 0 .668.511 1.21 1.14 1.21Zm-18.33 4.83c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M136.249 271.7c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.539 1.24c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M134.84 273.48c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M136.09 273.48c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M137.02 272.94c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm-6.22 2.46c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.575 0-1.04.569-1.04 1.27 0 .701.465 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M132.26 275.03c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.53 1.24c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M130.85 276.81c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M132.1 276.81c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M133.04 276.27c.63 0 1.14-.542 1.14-1.21 0-.668-.51-1.21-1.14-1.21-.629 0-1.14.542-1.14 1.21 0 .668.511 1.21 1.14 1.21Zm-14.88 10.81c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M119.619 286.72c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.539 1.23c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M118.21 288.5c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M119.46 288.5c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M120.39 287.95c.63 0 1.14-.542 1.14-1.21 0-.668-.51-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm-9.01-.1c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.575 0-1.04.569-1.04 1.27 0 .701.465 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M112.839 287.49c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.539 1.23c.568 0 1.03-.542 1.03-1.21 0-.668-.462-1.21-1.03-1.21-.569 0-1.03.542-1.03 1.21 0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M111.43 289.27c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M112.68 289.27c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M113.61 288.72c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm49.91-19.82c.574 0 1.039-.569 1.039-1.27 0-.701-.465-1.27-1.039-1.27-.575 0-1.041.569-1.041 1.27 0 .701.466 1.27 1.041 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M164.99 268.54c.491 0 .89-.488.89-1.09 0-.602-.399-1.09-.89-1.09-.492 0-.89.488-.89 1.09 0 .602.398 1.09.89 1.09Zm-2.54 1.23c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M163.57 270.31c.601 0 1.09-.542 1.09-1.21 0-.668-.489-1.21-1.09-1.21-.602 0-1.091.542-1.091 1.21 0 .668.489 1.21 1.091 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M164.82 270.31c.601 0 1.09-.542 1.09-1.21 0-.668-.489-1.21-1.09-1.21-.602 0-1.091.542-1.091 1.21 0 .668.489 1.21 1.091 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M165.76 269.77c.63 0 1.14-.542 1.14-1.21 0-.668-.51-1.21-1.14-1.21-.629 0-1.14.542-1.14 1.21 0 .668.511 1.21 1.14 1.21Zm3.109 1.68c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M170.329 271.09c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.529 1.23c.568 0 1.03-.542 1.03-1.21 0-.668-.462-1.21-1.03-1.21-.569 0-1.03.542-1.03 1.21 0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M168.919 272.86c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M170.169 272.86c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M171.11 272.32c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm40.849 34.72c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M213.419 306.68c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.53 1.23c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21-.568 0-1.03.542-1.03 1.21 0 .668.462 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M212.009 308.46c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M213.259 308.46c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M214.2 307.91c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Zm-7.91-2.48c.574 0 1.04-.569 1.04-1.27 0-.701-.466-1.27-1.04-1.27-.574 0-1.04.569-1.04 1.27 0 .701.466 1.27 1.04 1.27Z"
        fill="#87AC57"
      />
      <path
        d="M207.749 305.07c.492 0 .89-.488.89-1.09 0-.602-.398-1.09-.89-1.09-.491 0-.89.488-.89 1.09 0 .602.399 1.09.89 1.09Zm-2.539 1.23c.569 0 1.03-.542 1.03-1.21 0-.668-.461-1.21-1.03-1.21s-1.03.542-1.03 1.21c0 .668.461 1.21 1.03 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M206.329 306.84c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M207.59 306.84c.602 0 1.09-.542 1.09-1.21 0-.668-.488-1.21-1.09-1.21-.602 0-1.09.542-1.09 1.21 0 .668.488 1.21 1.09 1.21Z"
        fill="#87AC57"
      />
      <path
        d="M208.52 306.3c.629 0 1.14-.542 1.14-1.21 0-.668-.511-1.21-1.14-1.21-.63 0-1.14.542-1.14 1.21 0 .668.51 1.21 1.14 1.21Z"
        fill="#87AC57"
      />
      <path d="m120.15 293.67-1.25 4.79-9.19.4 1.66-4.85 8.78-.34Z" fill="#E1E1E1" />
      <path d="m120.36 291.18-.21 2.49-8.79.34 9-2.83Z" fill="#AD8D6A" />
      <path d="m119.11 302.18-9.4.45v-3.77l9.4-.41v3.73Z" fill="#EFF3F4" />
      <path d="m120.36 293.12-1.25 9.06v-3.73l1.25-5.73v.4Z" fill="#E1E1E1" />
      <path d="m111.36 294.01 9-2.83-1.25 4.68-9.4 3 1.65-4.85Z" fill="#EE6843" />
      <path d="m115.7 301.09-3 .14V300l3-.13v1.22Z" fill="#93CEEE" />
      <path
        d="M119.11 295.86v2.59l-9.4.41 9.4-3Zm1.25-3.14-1.25 5.73v-2.59l1.25-4.68v1.54Z"
        fill="#DD582B"
      />
      <path d="m83 290.52.91 2.24-.5.03-.41-2.27Z" fill="#87AC57" />
      <path d="m84.25 290.5-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m83.65 290.47.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m86.3 290.98-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m85.71 290.95.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m85.29 292.25-.05 2.27-.5-.02.55-2.25Z" fill="#87AC57" />
      <path
        d="m84.7 292.22.36 2.28-.51-.02.15-2.26Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m86.72 293.37-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m86.13 293.34.36 2.28-.5-.01.14-2.27Zm-3.75-.08.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m83.63 293.23-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m83.03 293.2.36 2.28-.5-.01.14-2.27Zm20.67.18.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m104.941 293.36-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m104.35 293.33.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m107 293.84-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m106.4 293.81.37 2.28-.51-.01.14-2.27Zm-1.66 1.31.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m105.991 295.1-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m105.39 295.07.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m107.42 296.22-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m106.82 296.19.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m104.321 296.09-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m103.72 296.06.37 2.28-.51-.01.14-2.27Zm-12.41-41.23.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m92.56 254.81-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m91.96 254.78.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m94.61 255.29-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m94.01 255.26.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m93.6 256.55-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m93 256.52.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m95.03 257.67-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m94.43 257.64.37 2.28-.51-.01.14-2.27Zm-3.74-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m91.93 257.54-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m91.33 257.51.37 2.28-.51-.01.14-2.27Zm1.17-15.87.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m93.75 241.61-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m93.15 241.58.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m95.8 242.09-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m95.21 242.06.36 2.28-.51-.01.15-2.27Zm-1.67 1.32.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m94.79 243.36-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m94.19 243.33.37 2.28-.51-.01.14-2.27Zm.79 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m96.22 244.48-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m95.63 244.45.36 2.28-.51-.01.15-2.27Zm-3.75-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m93.12 244.34-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m92.53 244.31.36 2.29-.51-.02.15-2.27Zm-9.28 20.23.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m84.5 264.52-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m83.9 264.49.37 2.28-.51-.01.14-2.27Zm1.41.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m86.55 265-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m85.96 264.97.36 2.28-.51-.01.15-2.27Zm-1.66 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m85.54 266.26-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m84.95 266.23.36 2.28-.51-.01.15-2.27Zm.78 1.18.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m86.97 267.38-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m86.38 267.35.36 2.28-.51-.01.15-2.27Zm-3.75-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m83.88 267.25-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m83.28 267.22.36 2.28-.5-.01.14-2.27Zm-1.06-11.89.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m83.46 255.3-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m82.87 255.27.36 2.28-.51-.01.15-2.27Zm1.4.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m85.52 255.78-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m84.92 255.75.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m84.51 257.05-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m83.91 257.02.36 2.28-.5-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m85.94 258.17-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m85.34 258.14.36 2.28-.5-.01.14-2.27Zm-3.75-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m82.84 258.04-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m82.24 258.01.37 2.28-.51-.02.14-2.26Zm29.27-14.55.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m112.76 243.43-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m112.16 243.4.37 2.28-.51-.01.14-2.27Zm1.409.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m114.809 243.91-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m114.219 243.88.36 2.28-.51-.01.15-2.27Zm-1.669 1.32.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m113.8 245.18-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m113.2 245.15.37 2.28-.51-.01.14-2.27Zm.789 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m115.229 246.3-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m114.639 246.27.36 2.28-.51-.01.15-2.27Zm-3.749-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m112.13 246.17-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m111.54 246.14.36 2.28-.51-.01.15-2.27Zm11.39 18.38.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m124.17 264.5-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m123.58 264.47.36 2.28-.51-.01.15-2.27Zm1.399.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m126.23 264.98-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m125.629 264.95.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m125.22 266.24-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m124.619 266.21.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m126.65 267.36-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m126.049 267.33.37 2.28-.51-.01.14-2.27Zm-3.749-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m123.55 267.23-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m122.95 267.2.37 2.28-.51-.01.14-2.27Zm-9.98 6.16.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m114.209 273.33-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m113.62 273.3.36 2.28-.51-.01.15-2.27Zm1.4.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m116.27 273.81-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m115.669 273.78.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m115.26 275.08-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m114.66 275.05.36 2.28-.5-.01.14-2.27Zm.779 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m116.69 276.2-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m116.089 276.17.37 2.28-.51-.01.14-2.27Zm-3.749-.08.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m113.59 276.06-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m112.99 276.03.37 2.28-.51-.01.14-2.27Zm22.5-41.1.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m136.741 234.9-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m136.14 234.87.36 2.29-.5-.02.14-2.27Zm1.4.54.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m138.79 235.39-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m138.19 235.35.37 2.29-.51-.02.14-2.27Zm-1.66 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m137.781 236.65-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m137.18 236.62.37 2.28-.51-.01.14-2.27Zm.78 1.17.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m139.21 237.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m138.61 237.74.37 2.28-.51-.01.14-2.27Zm-3.74-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m136.11 237.64-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m135.52 237.61.36 2.28-.51-.01.15-2.27Zm4.11-18.55.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m140.87 219.04-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m140.28 219.01.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m142.93 219.52-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.329 219.49.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m141.92 220.78-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m141.32 220.75.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m143.35 221.9-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.749 221.87.37 2.28-.51-.01.14-2.27Zm-3.749-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m140.25 221.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m139.65 221.74.37 2.28-.51-.01.14-2.27Zm2.47 8.83.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m143.36 230.55-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.77 230.52.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m145.42 231.03-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m144.82 231 .36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m144.411 232.29-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m143.81 232.26.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m145.84 233.41-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m145.24 233.38.36 2.29-.5-.02.14-2.27Zm-3.75-.07.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m142.741 233.28-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.14 233.25.37 2.28-.51-.01.14-2.27Zm35.889-10.33.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m179.269 222.9-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m178.679 222.87.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m181.33 223.38-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m180.729 223.35.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m180.32 224.64-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m179.719 224.61.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m181.749 225.76-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m181.149 225.73.37 2.28-.51-.01.14-2.27Zm-3.75-.07.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m178.65 225.63-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m178.049 225.6.37 2.28-.51-.01.14-2.27Zm6.971 3.74.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m186.27 229.32-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m185.669 229.29.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m188.32 229.8-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m187.729 229.77.36 2.28-.51-.01.15-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m187.309 231.07-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m186.719 231.04.36 2.28-.51-.02.15-2.26Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m188.739 232.19-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m188.149 232.16.36 2.28-.51-.01.15-2.27Zm-3.75-.08.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m185.65 232.05-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m185.049 232.02.36 2.28-.5-.01.14-2.27Zm15.571 13.62.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m201.871 245.62-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m201.27 245.59.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m203.92 246.1-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m203.32 246.07.37 2.28-.51-.01.14-2.27Zm-1.66 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m202.911 247.36-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m202.31 247.33.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m204.34 248.48-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m203.74 248.45.37 2.28-.51-.01.14-2.27Zm-3.74-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m201.24 248.35-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m200.65 248.32.36 2.28-.51-.01.15-2.27Zm1.23 4.74.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m203.13 253.04-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m202.53 253.01.37 2.28-.51-.01.14-2.27Zm1.409.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m205.19 253.52-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m204.589 253.49.36 2.28-.5-.01.14-2.27Zm-1.659 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m204.17 254.78-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m203.579 254.75.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m205.61 255.9-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m205.009 255.87.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m202.51 255.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m201.91 255.74.37 2.28-.51-.01.14-2.27Zm-24.931-24.64.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m178.23 231.07-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m177.629 231.04.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m180.289 231.55-.06 2.28-.5-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m179.689 231.52.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m179.27 232.82-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m178.679 232.79.36 2.28-.51-.01.15-2.27Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m180.709 233.94-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m180.109 233.91.36 2.28-.5-.01.14-2.27Zm-3.75-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m177.61 233.81-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m177.009 233.78.37 2.28-.51-.01.14-2.27Zm-35.079 5.37.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m143.18 239.13-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m142.579 239.1.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m145.23 239.61-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m144.629 239.58.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m144.22 240.87-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m143.619 240.84.371 2.28-.511-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m145.65 241.99-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m145.049 241.96.37 2.28-.51-.01.14-2.27Zm-3.739-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m142.55 241.86-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m141.96 241.83.36 2.28-.51-.01.15-2.27Zm74.24 40.92.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m217.451 282.72-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m216.85 282.69.37 2.28-.51-.01.14-2.27Zm1.41.54.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m219.5 283.2-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m218.91 283.17.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m218.49 284.47-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m217.9 284.44.36 2.28-.51-.01.15-2.27Zm.78 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m219.93 285.59-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m219.329 285.56.36 2.28-.5-.01.14-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m216.831 285.46-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m216.23 285.43.36 2.28-.5-.02.14-2.26Zm1.54 26.66.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m219.01 312.06-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m218.42 312.03.36 2.28-.51-.01.15-2.27Zm1.399.54.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m221.07 312.54-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m220.469 312.51.37 2.29-.51-.02.14-2.27Zm-1.659 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m220.06 313.81-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m219.459 313.78.37 2.28-.51-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m221.49 314.93-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m220.889 314.9.37 2.28-.51-.01.14-2.27Zm-3.749-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m218.39 314.8-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m217.789 314.77.37 2.28-.51-.01.14-2.27Zm36.221-12.98.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m255.26 301.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m254.66 301.74.37 2.28-.51-.01.14-2.27Zm1.409.53.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m257.309 302.25-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m256.719 302.22.36 2.28-.51-.01.15-2.27Zm-1.659 1.32.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m256.299 303.51-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m255.71 303.48.36 2.28-.51-.01.15-2.27Zm.779 1.18.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m257.729 304.63-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m257.139 304.6.36 2.28-.51-.01.15-2.27Zm-3.749-.08.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m254.64 304.5-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m254.039 304.47.36 2.28-.5-.01.14-2.27Zm18.091 1.59.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m273.38 306.04-.05 2.27-.51-.02.56-2.25Z" fill="#87AC57" />
      <path
        d="m272.78 306 .37 2.29-.51-.02.14-2.27Zm1.409.54.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m275.43 306.52-.05 2.27-.5-.02.55-2.25Z" fill="#87AC57" />
      <path
        d="m274.839 306.49.36 2.28-.51-.02.15-2.26Zm-1.659 1.31.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m274.419 307.78-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m273.83 307.75.36 2.28-.51-.01.15-2.27Zm.779 1.17.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m275.85 308.9-.05 2.27-.5-.01.55-2.26Z" fill="#87AC57" />
      <path
        d="m275.259 308.87.36 2.28-.51-.01.15-2.27Zm-3.749-.08.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m272.76 308.77-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m272.16 308.74.36 2.28-.5-.01.14-2.27Zm-120.681-4.27.901 2.24-.5.03-.401-2.27Z"
        fill="#87AC57"
      />
      <path d="m152.73 304.45-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m152.129 304.42.36 2.28-.5-.01.14-2.27Zm1.4.53.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m154.78 304.93-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m154.179 304.9.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m153.77 306.19-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m153.169 306.16.37 2.28-.51-.01.14-2.27Zm.78 1.18.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m155.2 307.31-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m154.599 307.28.37 2.28-.51-.01.14-2.27Zm-3.74-.07.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m152.099 307.18-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m151.509 307.15.36 2.28-.51-.01.15-2.27Zm9.881-.12.9 2.23-.5.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m162.63 307-.05 2.28-.5-.02.55-2.26Z" fill="#87AC57" />
      <path
        d="m162.04 306.97.36 2.28-.51-.01.15-2.27Zm1.399.54.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m164.69 307.48-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m164.089 307.45.37 2.28-.51-.01.14-2.27Zm-1.659 1.32.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m163.68 308.75-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m163.079 308.72.36 2.28-.5-.01.14-2.27Zm.78 1.17.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m165.11 309.87-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m164.509 309.84.37 2.28-.51-.01.14-2.27Zm-3.749-.08.91 2.23-.5.03-.41-2.26Z"
        fill="#87AC57"
      />
      <path d="m162.01 309.73-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m161.41 309.7.37 2.28-.51-.01.14-2.27Zm-5.921-37.25.9 2.24-.5.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m156.729 272.43-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m156.139 272.4.36 2.28-.51-.01.15-2.27Zm1.4.53.91 2.24-.51.03-.4-2.27Z"
        fill="#87AC57"
      />
      <path d="m158.789 272.91-.049 2.27-.511-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m158.189 272.88.36 2.28-.5-.01.14-2.27Zm-1.66 1.32.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m157.78 274.17-.06 2.27-.5-.01.56-2.26Z" fill="#87AC57" />
      <path
        d="m157.179 274.14.36 2.28-.5-.01.14-2.27Zm.78 1.18.91 2.23-.51.03-.4-2.26Z"
        fill="#87AC57"
      />
      <path d="m159.209 275.29-.05 2.28-.51-.02.56-2.26Z" fill="#87AC57" />
      <path
        d="m158.609 275.26.37 2.28-.51-.01.14-2.27Zm-3.75-.08.91 2.24-.5.03-.41-2.27Z"
        fill="#87AC57"
      />
      <path d="m156.11 275.16-.05 2.27-.51-.01.56-2.26Z" fill="#87AC57" />
      <path d="m155.509 275.13.37 2.28-.51-.01.14-2.27Z" fill="#87AC57" />
      <path
        d="M339.49 224.97c-1.31-2.38-4.44-2.97-6.58-1.3-1.01.78-2.02 2.05-2.57 4.11-1.38 5.1-3.15 15.49 4.94 15.5 8.45.02 5.9-13.06 5.58-14.12-.18-.59-.45-2.54-1.36-4.19h-.01Z"
        fill="#5E8038"
      />
      <path d="m335.29 229.06-.93 23.04h1.58l-.65-23.04Z" fill="#835D4C" />
      <path
        d="m332.48 234.89 2.81 1.3v1.4l-2.81-2.7Zm4.8-1.6-1.99.92v.98l1.99-1.9Zm1.45 3.31-3.44 1.59v1.7l3.44-3.29Z"
        fill="#835D4C"
      />
      <path
        d="M351.01 228.35c-1.31-2.38-4.44-2.97-6.58-1.3-1.01.78-2.02 2.05-2.57 4.11-1.38 5.1-3.15 15.49 4.94 15.5 8.45.02 5.9-13.06 5.58-14.12-.18-.59-.45-2.54-1.36-4.19h-.01Z"
        fill="#87AC57"
      />
      <path d="m346.82 232.43-.93 23.05h1.57l-.64-23.05Z" fill="#835D4C" />
      <path
        d="m344 238.27 2.82 1.3v1.39l-2.82-2.69Zm4.81-1.6-1.99.92v.98l1.99-1.9Zm1.44 3.31-3.43 1.59v1.7l3.43-3.29Z"
        fill="#835D4C"
      />
      <path
        d="M363.12 231.73c-1.31-2.38-4.44-2.97-6.58-1.3-1.01.78-2.02 2.05-2.57 4.11-1.38 5.1-3.15 15.49 4.94 15.5 8.45.02 5.9-13.06 5.58-14.12-.18-.59-.45-2.54-1.36-4.19h-.01Z"
        fill="#5E8038"
      />
      <path d="m358.93 235.82-.93 23.04h1.57l-.64-23.04Z" fill="#835D4C" />
      <path
        d="m356.11 241.65 2.82 1.31v1.39l-2.82-2.7Zm4.811-1.6-1.99.92v.99l1.99-1.91Zm1.44 3.31-3.43 1.59v1.7l3.43-3.29Z"
        fill="#835D4C"
      />
      <path
        d="M374.8 235.47c-1.31-2.38-4.44-2.97-6.58-1.3-1.01.78-2.02 2.05-2.57 4.11-1.38 5.1-3.15 15.49 4.94 15.5 8.45.02 5.9-13.06 5.58-14.12-.18-.59-.45-2.54-1.36-4.19h-.01Z"
        fill="#5E8038"
      />
      <path d="m370.61 239.55-.93 23.05h1.58l-.65-23.05Z" fill="#835D4C" />
      <path
        d="m367.8 245.39 2.81 1.3v1.4l-2.81-2.7Zm4.799-1.6-1.99.92v.98l1.99-1.9Zm1.45 3.31-3.44 1.59v1.7l3.44-3.29Z"
        fill="#835D4C"
      />
      <path
        d="M402.6 231.79c-1.33-2.42-4.52-3.02-6.7-1.32-1.02.8-2.05 2.09-2.62 4.18-1.4 5.18-3.21 15.75 5.02 15.77 8.59.02 6-13.28 5.67-14.36-.18-.6-.46-2.58-1.38-4.27h.01Z"
        fill="#5E8038"
      />
      <path d="m398.339 235.95-.94 23.44h1.59l-.65-23.44Z" fill="#835D4C" />
      <path
        d="m395.479 241.89 2.86 1.32v1.42l-2.86-2.74Zm4.881-1.63-2.02.93v1l2.02-1.93Zm1.48 3.36-3.5 1.62v1.73l3.5-3.35Z"
        fill="#835D4C"
      />
      <path
        d="M414.329 235.23c-1.33-2.42-4.52-3.02-6.7-1.32-1.02.8-2.05 2.09-2.62 4.18-1.4 5.18-3.21 15.75 5.02 15.77 8.23.02 6-13.28 5.67-14.36-.18-.6-.46-2.58-1.38-4.27h.01Z"
        fill="#87AC57"
      />
      <path d="m410.059 239.39-.94 23.43h1.6l-.66-23.43Z" fill="#835D4C" />
      <path
        d="m407.199 245.32 2.86 1.33v1.41l-2.86-2.74Zm4.891-1.63-2.03.94v1l2.03-1.94Zm1.47 3.37-3.5 1.61v1.73l3.5-3.34Z"
        fill="#835D4C"
      />
      <path
        d="M426.64 238.67c-1.33-2.42-4.52-3.02-6.7-1.32-1.02.8-2.05 2.09-2.62 4.18-1.4 5.18-3.21 15.75 5.02 15.77 8.59.02 6-13.28 5.67-14.36-.18-.6-.46-2.58-1.38-4.27h.01Z"
        fill="#5E8038"
      />
      <path d="m422.38 242.83-.95 23.43h1.6l-.65-23.43Z" fill="#835D4C" />
      <path
        d="m419.52 248.76 2.86 1.33v1.41l-2.86-2.74Zm4.88-1.62-2.02.93v1l2.02-1.93Zm1.47 3.36-3.49 1.62v1.72l3.49-3.34Z"
        fill="#835D4C"
      />
      <path
        d="M438.53 242.47c-1.33-2.42-4.52-3.02-6.7-1.32-1.02.8-2.05 2.09-2.62 4.18-1.4 5.18-3.21 15.75 5.02 15.77 8.59.02 6-13.28 5.67-14.36-.18-.6-.46-2.58-1.38-4.27h.01Z"
        fill="#87AC57"
      />
      <path d="m434.259 246.63-.94 23.43h1.6l-.66-23.43Z" fill="#835D4C" />
      <path
        d="m431.399 252.56 2.86 1.33v1.41l-2.86-2.74Zm4.891-1.62-2.03.93v1l2.03-1.93Zm1.47 3.36-3.5 1.62v1.72l3.5-3.34Z"
        fill="#835D4C"
      />
      <path
        d="M174.899 289.02s-.07-3.57 2.94-3.74c3.54-.2 3.48 3.37 3.48 4.54 0 0 1.19 1 1.19 2.54s-.33 2.21-.33 2.21.85.81 1.05 2.21c.2 1.4-.79 2.19-.99 2.39 0 0 .41 1.71-.73 2.86-.73.74-1.8 1.4-3 1.27 0 0-.49.72-2.47.53-.93-.09-2.47-.87-2.67-2.74-.97-.46-1.6-1.54-1.47-3.07 0 0-1-.33-1-2.67 0-1.87 1.62-2.09 1.62-2.09s-.76-1.71.41-3.22c.87-1.12 1.97-1.03 1.97-1.03v.01Z"
        fill="#87AC57"
      />
      <path d="m177.69 290.49-.84 20.78h1.42l-.58-20.78Z" fill="#835D4C" />
      <path
        d="m175.149 295.75 2.54 1.18v1.25l-2.54-2.43Zm4.33-1.44-1.79.83v.89l1.79-1.72Zm1.31 2.98-3.1 1.44v1.53l3.1-2.97Z"
        fill="#835D4C"
      />
      <path
        d="M190 263.5s-.05-2.8 2.31-2.94c2.78-.16 2.73 2.65 2.73 3.56 0 0 .94.79.94 1.99s-.26 1.74-.26 1.74.67.63.83 1.73c.16 1.1-.62 1.72-.78 1.88 0 0 .32 1.34-.58 2.25-.57.58-1.41 1.1-2.36 1 0 0-.38.57-1.94.42-.73-.07-1.94-.68-2.1-2.15-.76-.36-1.26-1.2-1.15-2.41 0 0-.79-.26-.79-2.1 0-1.47 1.27-1.64 1.27-1.64s-.6-1.34.32-2.52c.68-.88 1.55-.81 1.55-.81h.01Z"
        fill="#87AC57"
      />
      <path d="m192.179 264.65-.65 16.31h1.11l-.46-16.31Z" fill="#835D4C" />
      <path
        d="m190.189 268.78 1.99.92v.99l-1.99-1.91Zm3.401-1.14-1.41.66v.69l1.41-1.35Zm1.03 2.35-2.44 1.12v1.2l2.44-2.32Z"
        fill="#835D4C"
      />
      <path
        d="M199.279 271.14s-.05-2.94 2.42-3.08c2.91-.16 2.86 2.78 2.86 3.73 0 0 .98.83.98 2.09 0 1.26-.27 1.82-.27 1.82s.7.67.87 1.82c.17 1.15-.65 1.8-.82 1.97 0 0 .34 1.41-.6 2.36-.6.61-1.48 1.15-2.47 1.04 0 0-.4.6-2.03.44-.76-.07-2.03-.71-2.2-2.25-.8-.38-1.32-1.26-1.21-2.53 0 0-.82-.27-.82-2.2 0-1.54 1.33-1.72 1.33-1.72s-.62-1.41.34-2.65c.72-.92 1.62-.85 1.62-.85v.01Z"
        fill="#87AC57"
      />
      <path d="m201.57 272.34-.69 17.11h1.17l-.48-17.11Z" fill="#835D4C" />
      <path
        d="m199.479 276.68 2.091.96v1.04l-2.091-2Zm3.57-1.19-1.48.68v.73l1.48-1.41Zm1.07 2.45-2.55 1.18v1.26l2.55-2.44Z"
        fill="#835D4C"
      />
      <path
        d="M141.95 278.52s-.06-3.23 2.66-3.38c3.2-.18 3.14 3.05 3.14 4.1 0 0 1.08.91 1.08 2.29s-.3 2-.3 2 .77.73.95 2c.18 1.27-.71 1.98-.89 2.16 0 0 .37 1.54-.66 2.59-.66.67-1.63 1.27-2.71 1.15 0 0-.44.65-2.23.48-.84-.08-2.23-.78-2.41-2.47-.88-.42-1.45-1.39-1.33-2.77 0 0-.9-.3-.9-2.41 0-1.69 1.46-1.89 1.46-1.89s-.69-1.54.37-2.91c.79-1.01 1.78-.93 1.78-.93l-.01-.01Z"
        fill="#87AC57"
      />
      <path d="m144.47 279.84-.76 18.78h1.28l-.52-18.78Z" fill="#835D4C" />
      <path
        d="m142.17 284.6 2.3 1.06v1.13l-2.3-2.19Zm3.92-1.31-1.62.75v.81l1.62-1.56Zm1.18 2.7-2.8 1.3v1.38l2.8-2.68Z"
        fill="#835D4C"
      />
      <path
        d="M163.67 227.67s-.06-3.54 2.91-3.7c3.5-.2 3.44 3.34 3.44 4.49 0 0 1.18.99 1.18 2.51 0 1.52-.32 2.19-.32 2.19s.84.8 1.04 2.19c.2 1.39-.78 2.17-.98 2.37 0 0 .41 1.69-.73 2.83-.72.73-1.78 1.39-2.97 1.26 0 0-.48.72-2.44.53-.92-.09-2.44-.86-2.64-2.71-.96-.46-1.59-1.52-1.45-3.04 0 0-.99-.33-.99-2.64 0-1.86 1.6-2.07 1.6-2.07s-.75-1.69.41-3.18c.86-1.11 1.95-1.02 1.95-1.02l-.01-.01Z"
        fill="#87AC57"
      />
      <path d="m166.42 229.13-.83 20.56H167l-.58-20.56Z" fill="#835D4C" />
      <path
        d="m163.91 234.34 2.51 1.16v1.24l-2.51-2.4Zm4.29-1.43-1.78.82v.88l1.78-1.7Zm1.29 2.95-3.07 1.42v1.51l3.07-2.93Z"
        fill="#835D4C"
      />
      <path
        d="M97.74 276.34s-.06-3.14 2.58-3.29c3.11-.18 3.05 2.96 3.05 3.98 0 0 1.05.88 1.05 2.23s-.29 1.94-.29 1.94.75.71.92 1.94c.17 1.23-.69 1.92-.87 2.1 0 0 .36 1.5-.64 2.51-.64.65-1.58 1.23-2.64 1.11 0 0-.43.64-2.17.47-.81-.08-2.17-.76-2.34-2.4-.86-.41-1.41-1.35-1.29-2.7 0 0-.88-.29-.88-2.34 0-1.65 1.42-1.83 1.42-1.83s-.67-1.5.36-2.82c.77-.99 1.73-.91 1.73-.91l.01.01Z"
        fill="#87AC57"
      />
      <path d="m100.18 277.63-.73 18.24h1.24l-.51-18.24Z" fill="#835D4C" />
      <path
        d="m97.95 282.25 2.23 1.03v1.1l-2.23-2.13Zm3.811-1.27-1.58.73v.78l1.58-1.51Zm1.14 2.62-2.72 1.26v1.34l2.72-2.6Z"
        fill="#835D4C"
      />
      <path
        d="M132.7 233.23c-.32-.49-2.66-3.96-2.66-3.96.64-.43 1.24-.88.88-1.51-.23-.42-3.24-4.87-3.24-4.87.75-.18 1.52-.48 1.36-1.07-.11-.41-3.31-5.01-3.31-5.01s-3.2 4.6-3.31 5.01c-.16.59.61.89 1.36 1.07 0 0-3.01 4.45-3.24 4.87-.36.63.24 1.09.88 1.51 0 0-2.33 3.48-2.66 3.96-.75 1.12 1.28 2.09 2.19 2.2 1.04.13 4.78.11 4.78.11s3.74.02 4.78-.11c.92-.11 3.02-.94 2.19-2.2Z"
        fill="#5E8038"
      />
      <path d="m125.73 222.41-.61 14.99h1.03l-.42-14.99Z" fill="#835D4C" />
      <path
        d="m123.9 226.21 1.83.84v.91l-1.83-1.75Zm-.339 3.25 1.83.84v.91l-1.83-1.75Zm-1.401 2.34 3.23 1.12v1.18l-3.23-2.3Zm4.86-6.64-1.29.6v.64l1.29-1.24Zm.95 2.16-2.24 1.03v1.11l2.24-2.14Zm.99 2.14-3.23 1.27v1.36l3.23-2.63Zm.92 2.11-4.15 1.6v1.71l4.15-3.31Z"
        fill="#835D4C"
      />
      <path
        d="M120.759 223.07c-.32-.49-2.66-3.96-2.66-3.96.64-.43 1.24-.88.88-1.51-.23-.42-3.24-4.87-3.24-4.87.75-.18 1.52-.48 1.36-1.07-.11-.41-3.31-5.01-3.31-5.01s-3.2 4.6-3.31 5.01c-.16.59.61.89 1.36 1.07 0 0-3.01 4.45-3.24 4.87-.36.63.24 1.09.88 1.51 0 0-2.33 3.48-2.66 3.96-.75 1.12 1.28 2.09 2.19 2.2 1.04.13 4.78.11 4.78.11s3.74.02 4.78-.11c.92-.11 3.02-.94 2.19-2.2Z"
        fill="#5E8038"
      />
      <path d="m113.78 212.25-.6 15h1.02l-.42-15Z" fill="#835D4C" />
      <path
        d="m111.95 216.05 1.83.85v.9l-1.83-1.75Zm-.33 3.25 1.83.85v.9l-1.83-1.75Zm-1.4 2.35 3.23 1.11v1.19l-3.23-2.3Zm4.859-6.64-1.3.6v.64l1.3-1.24Zm.94 2.15-2.24 1.04v1.1l2.24-2.14Zm1 2.14-3.24 1.28v1.36l3.24-2.64Zm.91 2.12-4.15 1.6v1.71l4.15-3.31Z"
        fill="#835D4C"
      />
      <path
        d="M137.59 213.73c-.33-.51-2.76-4.11-2.76-4.11.66-.44 1.28-.91.92-1.57-.24-.43-3.37-5.05-3.37-5.05.77-.18 1.58-.5 1.41-1.11-.09-.33-2.12-3.29-3.02-4.59-.2-.3-.64-.3-.84 0-.9 1.3-2.92 4.26-3.02 4.59-.17.61.64.92 1.41 1.11 0 0-3.12 4.62-3.37 5.05-.37.66.25 1.13.92 1.57 0 0-2.43 3.6-2.76 4.11-.58.91 1.32 2.17 2.27 2.29 1.08.13 4.96.11 4.96.11s3.88.02 4.96-.11c.95-.12 2.86-1.38 2.27-2.29h.02Z"
        fill="#5E8038"
      />
      <path d="m130.351 202.5-.63 15.56h1.06l-.43-15.56Z" fill="#835D4C" />
      <path
        d="m128.45 206.44 1.9.88v.94l-1.9-1.82Zm-.349 3.37 1.9.88v.94l-1.9-1.82Zm-1.451 2.44 3.35 1.16v1.23l-3.35-2.39Zm5.041-6.89-1.34.62v.66l1.34-1.28Zm.98 2.23-2.32 1.08v1.14l2.32-2.22Zm1.04 2.22-3.36 1.33v1.41l3.36-2.74Zm.95 2.2-4.31 1.66v1.78l4.31-3.44Z"
        fill="#835D4C"
      />
      <path
        d="M219.89 186.08c-.33-.51-2.76-4.11-2.76-4.11.66-.44 1.28-.91.92-1.57-.24-.43-3.37-5.05-3.37-5.05.77-.18 1.58-.5 1.41-1.11-.09-.33-2.12-3.29-3.02-4.59-.2-.3-.64-.3-.84 0-.9 1.3-2.92 4.26-3.02 4.59-.17.61.64.92 1.41 1.11 0 0-3.12 4.62-3.37 5.05-.37.66.25 1.13.92 1.57 0 0-2.43 3.6-2.76 4.11-.58.91 1.32 2.17 2.27 2.29 1.08.13 4.96.11 4.96.11s3.88.02 4.96-.11c.95-.12 2.86-1.38 2.27-2.29h.02Z"
        fill="#5E8038"
      />
      <path d="m212.65 174.85-.629 15.57h1.069l-.44-15.57Z" fill="#835D4C" />
      <path
        d="m210.75 178.79 1.9.88v.94l-1.9-1.82Zm-.35 3.38 1.9.88v.94l-1.9-1.82Zm-1.45 2.43 3.35 1.16v1.23l-3.35-2.39Zm5.05-6.89-1.35.62v.67l1.35-1.29Zm.97 2.24-2.32 1.07v1.15l2.32-2.22Zm1.04 2.22-3.36 1.32v1.41l3.36-2.73Zm.95 2.2-4.31 1.66v1.77l4.31-3.43Z"
        fill="#835D4C"
      />
      <path
        d="M230.409 193.81c-.33-.51-2.76-4.11-2.76-4.11.66-.44 1.28-.91.92-1.57-.24-.43-3.37-5.05-3.37-5.05.77-.18 1.58-.5 1.41-1.11-.09-.33-2.12-3.29-3.02-4.59-.2-.3-.64-.3-.84 0-.9 1.3-2.92 4.26-3.02 4.59-.17.61.64.92 1.41 1.11 0 0-3.12 4.62-3.37 5.05-.37.66.25 1.13.92 1.57 0 0-2.43 3.6-2.76 4.11-.58.91 1.32 2.17 2.27 2.29 1.08.13 4.96.11 4.96.11s3.88.02 4.96-.11c.95-.12 2.86-1.38 2.27-2.29h.02Z"
        fill="#5E8038"
      />
      <path d="m223.17 182.58-.63 15.56h1.06l-.43-15.56Z" fill="#835D4C" />
      <path
        d="m221.27 186.52 1.9.88v.94l-1.9-1.82Zm-.35 3.37 1.9.88v.94l-1.9-1.82Zm-1.45 2.44 3.35 1.16v1.23l-3.35-2.39Zm5.04-6.89-1.34.62v.67l1.34-1.29Zm.98 2.23-2.32 1.08v1.14l2.32-2.22Zm1.03 2.22-3.35 1.33v1.41l3.35-2.74Zm.96 2.2-4.31 1.66v1.78l4.31-3.44Z"
        fill="#835D4C"
      />
      <path
        d="M242.25 187.72c-.33-.51-2.76-4.11-2.76-4.11.66-.44 1.28-.91.92-1.57-.24-.43-3.37-5.05-3.37-5.05.77-.18 1.58-.5 1.41-1.11-.09-.33-2.12-3.29-3.02-4.59-.2-.3-.64-.3-.84 0-.9 1.3-2.92 4.26-3.02 4.59-.17.61.64.92 1.41 1.11 0 0-3.12 4.62-3.37 5.05-.37.66.25 1.13.92 1.57 0 0-2.43 3.6-2.76 4.11-.58.91 1.32 2.17 2.27 2.29 1.08.13 4.96.11 4.96.11s3.88.02 4.96-.11c.95-.12 2.86-1.38 2.27-2.29h.02Z"
        fill="#5E8038"
      />
      <path d="m235.011 176.49-.62 15.57h1.06l-.44-15.57Z" fill="#835D4C" />
      <path
        d="m233.11 180.43 1.9.88v.94l-1.9-1.82Zm-.349 3.38 1.9.88v.94l-1.9-1.82Zm-1.45 2.43 3.35 1.16v1.23l-3.35-2.39Zm5.05-6.89-1.35.62v.67l1.35-1.29Zm.97 2.24-2.32 1.07v1.15l2.32-2.22Zm1.04 2.22-3.36 1.32v1.41l3.36-2.73Zm.95 2.2-4.31 1.66v1.77l4.31-3.43Z"
        fill="#835D4C"
      />
      <path
        d="M246.09 198.8c-1.07-1.95-3.63-2.43-5.38-1.06-.82.64-1.65 1.68-2.1 3.36-1.13 4.17-2.58 12.67 4.04 12.68 6.91.01 4.82-10.68 4.56-11.55-.15-.49-.37-2.08-1.11-3.43h-.01Z"
        fill="#5E8038"
      />
      <path d="m242.669 202.14-.76 18.85h1.28l-.52-18.85Z" fill="#835D4C" />
      <path
        d="m240.359 206.92 2.31 1.06v1.14l-2.31-2.2Zm3.93-1.31-1.62.75v.8l1.62-1.55Zm1.19 2.7-2.81 1.3V211l2.81-2.69Z"
        fill="#835D4C"
      />
      <path
        d="M236.189 195.44c-1.07-1.95-3.63-2.43-5.38-1.06-.82.64-1.65 1.68-2.1 3.36-1.13 4.17-2.58 12.67 4.04 12.68 6.91.01 4.82-10.68 4.56-11.55-.15-.49-.37-2.08-1.11-3.43h-.01Z"
        fill="#87AC57"
      />
      <path d="m232.759 198.79-.76 18.84h1.29l-.53-18.84Z" fill="#835D4C" />
      <path
        d="m230.459 203.56 2.3 1.07v1.13l-2.3-2.2Zm3.93-1.31-1.63.75v.81l1.63-1.56Zm1.18 2.71-2.81 1.3v1.39l2.81-2.69Z"
        fill="#835D4C"
      />

      <mask
        id="b"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="75"
        y="169"
        width="404"
        height="152"
      >
        <path
          d="M441.97 270.61c-5.11-31.99-21.03-39.03-46.49-62.16-31.14-28.29-73.61-38.25-117.65-38.25-5.39 0-13.22-.66-18.53-.47-5.31-.19-13.14.47-18.53.47-44.04 0-86.51 9.95-117.65 38.25-25.46 23.13-41.37 30.17-46.49 62.16-1.85 11.58-.81 29.17 13.97 34.39.87.31 4.47 1.34 5.36 1.55 8.2 1.9 53.09 10.9 142.92 13.36 7.27.2 14.06.37 20.42.5 6.36-.14 13.15-.3 20.42-.5 89.83-2.46 134.81-7.85 143.01-9.75.9-.21 7.34-.08 8.26-.19 23.38-2.6 41.55-10.23 47.59-12.92 1.34-.6-29.05-7.62-28.79-8.86 1.08-5.03-7.12-13.2-7.82-17.58Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#b)">
        <path d="m475.529 301.26-8.53 2.84-321.33-114.51h.35l329.51 111.67Z" fill="#C2B29B" />
        <path d="m471.629 306.2-329.75-117.96v-.03l329.75 114.58v3.41Z" fill="#AFA08C" />
        <path
          d="M319.839 323.1v-4.05l129.3-24.6v3.29l-129.3 25.36Zm-46.26-34.75v-3.14l107.82-14.3v2.69l-107.82 14.75Zm-40.309-29.89v-2.2l84.03-7.45v1.97l-84.03 7.68Zm-83.931-63.33v-.21l11.57-.1v.21l-11.57.1Zm9.34 6.87v-.43l20.79-.35v.42l-20.79.36Zm11.86 8.8v-.7l32.09-.88v.68l-32.09.9Z"
          fill="#837468"
        />
        <path
          d="m317.299 248.81-12.62-4.54-78.63 6.83 7.22 5.18 84.03-7.47Zm64.101 22.1-18.38-6.42-103.75 11.03 14.31 9.68 107.82-14.29Zm-152.291-52.56-6.67-2.25-42.53 1.34 3.87 2.71 45.33-1.8Zm-26.48-9.13-4.19-1.51-29.53 1.25 1.63 1.15 32.09-.89Zm-25.62-8.84 2.47.84-20.8.35-1.07-.74 19.4-.45Zm-16.6-5.74.5.18-11.57.1-.26-.18 11.33-.1Zm288.73 99.81-29.11-10.1-120.39 19.96 20.2 14.76 129.3-24.62Zm-178.64-61.82-8.62-3.02-61.19 3.15 5.4 3.58 64.41-3.71Z"
          fill="#978475"
        />
        <path
          d="M183.799 221.18v-1.03l45.31-1.8v.97l-45.31 1.86Zm22.29 16.68v-1.54l64.41-3.69v1.43l-64.41 3.8Z"
          fill="#837468"
        />
        <path d="m331.019 324.14-15.82 3.18-173.34-137.72h.36l188.8 134.54Z" fill="#C2B29B" />
        <path d="M318.389 329.86 141.859 189.6v-.06l176.53 136.91v3.41Z" fill="#AFA08C" />
      </g>
      <g clip-path="url(#c)">
        <path
          d="M446.531 72.19a7.907 7.907 0 0 0-1.943-1.03c.049-.06.109-.11.159-.17 2.591-2.81 3.857-6.65 3.668-11.12a3.985 3.985 0 0 0-3.987-3.83h-2.88a4.06 4.06 0 0 0-1.754-.94c-3.379-.81-6.08.47-7.416 3.51-.069.16-.279.4-.418.5-.509.33-.957.72-1.336 1.14h-.548c-.259 0-.508.03-.767.08.019-.17.029-.35.029-.52.03-3.1-2.551-5.76-5.631-5.81-1.485-.04-2.92.54-4.006 1.57h-.718c-.399 0-.797.06-1.176.18a3.751 3.751 0 0 0-1.106-.16h-2.343c-.707 0-1.375.19-1.953.52-.13-.1-.269-.2-.409-.29a3.948 3.948 0 0 0-3.508-.3c-.419.17-.777.31-1.096.46a4.42 4.42 0 0 0-1.177-.79c-1.843-.86-3.468-.24-4.086 0-.678.18-1.256.46-1.744.75a9.213 9.213 0 0 0-1.973-.51 4.003 4.003 0 0 0-3.01.79s-.02.01-.03.02c-1.047-.68-2.293-1.09-3.658-1.16-1.675-.09-3.339-.07-4.954-.05-.657 0-1.325.02-2.003.02-.468 0-.937.08-1.375.25-.399-.13-.818-.2-1.246-.2h-2.193a3.992 3.992 0 0 0-3.987 4V63h-1.933a3.97 3.97 0 0 0-3.967 3.64c-.259 2.94.598 4.9 1.595 6.16-1.705 1.49-2.651 3.77-2.651 6.58 0 6.06-.01 12.11 0 18.17 0 4.96 3.458 8.42 8.382 8.42h64.206c4.933 0 8.392-3.46 8.402-8.41.01-6.14.02-12.28 0-18.42 0-2.84-1.266-5.38-3.459-6.96v.01Z"
          fill="#fff"
        />
        <path fill="url(#d)" d="M371.99 58.016h75.457v45.425H371.99z" />
      </g>
    </g>
  );
}

export default Background;
